import React from 'react';

const Markets = ({ onMouseMove, onMouseLeave }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      baseProfile="tiny"
      height="480"
      strokeLinecap="round"
      strokeLinejoin="round"
      version="1.2"
      viewBox="0 0 800 540"
      width="700"
      id="Market"
    >
      <g id="DMA_All_US" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
        <path
          className="white"
          d="M 756.5 113.75 752.8 107.38 744.03 105.24 742.96 102.96 745.56 101.83 745 98.9 737.78 94.09 739.94 89.92 737.86 87.2 738.29 81.88 739.58 75.85 745.91 75.43 745.48 71.72 747.9 71.55 746.02 69.87 747.45 66.39 751.87 75.6 755.35 74.97 761.05 83.72 765.51 83.13 764.5 80.94 766.54 80.01 768.76 82.85 768.06 87.1 774.89 87 774.14 93.59 774.06 90.85 772.77 93.54 771.09 91.2 770.78 96.43 767.97 96.21 767.09 100.24 765.53 96.47 764.38 100.4 764.73 97.58 762.81 98.6 759.14 114.97 756.5 113.75 Z"
          data-mrisynd="dma 500"
          data-state_name="Portland-Auburn, ME"
          id="500"
        />
        <path
          className="white"
          d="M 723.51 194.09 722.95 189.97 717.98 182.99 719.47 180.84 710.64 179.97 707.77 176.67 708.85 171.48 707.45 169.77 709.06 166.89 706.16 166.43 706.15 164.41 702.96 165.38 705.77 157.27 704.55 154.52 703.36 153.18 711.64 144.99 725.51 144.08 726.82 151.4 734.79 156.76 734.76 159.34 722.25 171.71 721.25 176.04 725.93 176.72 726.04 178.64 725.43 175.42 726.32 177.47 727.21 189.14 726.47 183.28 724.91 186 726.33 186.07 726.54 190.39 725.3 194.69 723.51 194.09 Z M 741.8 165 725.96 173.99 728.3 171.49 724.17 172.84 730.55 164.82 742.32 161.22 747.12 156.42 742.55 162.47 744.74 162.36 746.54 158.98 752.78 156.78 741.8 165 Z M 722.05 173.66 724.12 173.27 721.79 175.87 722.05 173.66 Z M 743.3 164.66 741.69 165.75 745.18 163.3 743.3 164.66 Z"
          data-mrisynd="dma 501"
          data-state_name="New York, NY"
          fillRule="evenodd"
          id="501"
        />
        <path
          className="white"
          d="M 706.54 139.23 711.18 141.52 710.31 144.64 711.64 144.99 703.36 153.18 699.76 151.02 683.08 154.57 682.25 149.19 686.19 148.07 685.15 146.22 691.06 144.68 689.45 138.94 697.55 136.78 697.67 145.26 706.54 139.23 Z"
          data-mrisynd="dma 502"
          data-state_name="Binghamton, NY"
          id="502"
        />
        <path
          className="white"
          d="M 627.69 353.76 623.96 355.12 626.67 361.51 622.28 364.98 609.65 365.96 609.25 362.62 603.57 363.31 598.19 358.83 601.7 353.8 598.1 351.18 599.44 341.05 611.01 340.19 615.07 333.8 615.37 333.97 618.18 334.18 623.62 341.37 626.18 346.02 623.45 351.27 627.69 353.76 Z"
          data-mrisynd="dma 503"
          data-state_name="Macon, GA"
          id="503"
        />
        <path
          className="white"
          d="M 707.45 169.77 708.85 171.48 707.77 176.67 710.64 179.97 719.47 180.84 717.98 182.99 722.95 189.97 723.51 194.09 723.93 197.94 721.15 199.42 718.77 207.72 718.22 202.92 714.75 203.61 706.61 197.52 713.22 208.61 707.72 212.1 703.12 195.42 698.13 196.51 698.55 195.98 700.21 187.82 690.68 182.73 707.45 169.77 Z"
          data-mrisynd="dma 504"
          data-state_name="Philadelphia, PA"
          id="504"
        />
        <path
          className="white"
          d="M 586.62 176.19 582.67 176.88 581.62 170.02 576.61 170.86 574.54 157.4 584.13 154.22 583.12 147.41 587.8 144.93 586.7 138.29 593.71 137.03 598.25 150.29 597.83 157.15 593.69 157.44 586.62 176.19 Z"
          data-mrisynd="dma 505"
          data-state_name="Detroit, MI"
          id="505"
        />
        <path
          className="white"
          d="M 764.06 142.62 760.78 140.49 758.45 134.77 749 139.03 744.26 139.8 740.3 134.56 738.92 127.37 730 129.26 727.33 122.37 729.1 119.22 740.29 118.9 738.59 113.13 744.03 105.24 752.8 107.38 756.5 113.75 755.89 116.31 758.69 115.75 758.73 122.57 762.38 122.79 758.29 125.53 759.82 126.49 758.94 129.68 756.67 129.05 757.78 131.48 761.96 130.65 768.18 138.46 764.06 142.62 Z M 773.88 134.24 770.05 132.19 773.66 132.76 776.08 138.81 766.77 144.01 766.57 139.77 771.68 138.96 774.6 136.55 773.88 134.24 Z M 770.17 146.41 765.56 147.86 768.13 144.43 770.17 146.41 Z M 777.26 144.88 777.73 146.64 774.26 146.76 777.26 144.88 Z"
          data-mrisynd="dma 506"
          data-state_name="Boston (Manchester), MA-NH"
          fillRule="evenodd"
          id="506"
        />
        <path
          className="white"
          d="M 646.97 371.54 642.9 369.04 641.62 371.68 632.91 369.02 627.08 371.06 626.04 367.24 622.65 367.75 622.28 364.98 626.67 361.51 623.96 355.12 627.69 353.76 630.62 354.02 639.57 338.5 642.63 343.9 646.92 337.73 657.53 346.03 652.03 346.58 654.36 351.16 652.45 355.26 653.87 356.66 649.57 362.64 647.55 361.76 650.3 364.61 646.97 371.54 Z M 658.57 348.22 656.27 351.22 654.84 346.89 658.57 348.22 Z M 653.08 347.91 654.63 346.3 655.83 350.67 653.08 347.91 Z M 655.32 353.32 653.73 354.45 654.89 351.22 655.32 353.32 Z"
          data-mrisynd="dma 507"
          data-state_name="Savannah, GA"
          fillRule="evenodd"
          id="507"
        />
        <path
          className="white"
          d="M 636.88 209.72 634.82 208.41 631.94 190.87 630.41 181.58 636.59 181.64 636.83 174.66 636.61 173.38 638.59 170.45 650.87 168.25 651.48 171.81 648.32 174.45 649.65 182.48 655.51 181.52 656.26 185.12 650.33 203.17 651.15 205.63 655.18 204.9 657.82 204.4 651.54 215.92 646.08 215.86 644.81 212.35 636.88 209.72 Z"
          data-mrisynd="dma 508"
          data-state_name="Pittsburgh, PA"
          id="508"
        />
        <path
          className="white"
          d="M 553.16 194.48 556.83 193.16 556.24 183.93 562.76 182.74 562.25 178.66 567.52 178.05 567.94 179.24 568.99 187.76 575.79 188.64 576.13 197.97 570.19 197.84 571.13 205.88 565.13 206.65 564.81 201.61 561.05 200.35 553.97 201.16 553.16 194.48 Z"
          data-mrisynd="dma 509"
          data-state_name="Ft. Wayne, IN"
          id="509"
        />
        <path
          className="white"
          d="M 627.72 165.3 629.23 174.43 622.38 175.5 623.52 190.48 627.15 192.42 626.53 195.95 621.79 196.52 621.47 200.88 617.33 201.24 615.44 197.27 601.99 197.19 599.33 188.86 597.84 189.05 595.63 180.88 611.93 177.4 627.72 165.3 Z"
          data-mrisynd="dma 510"
          data-state_name="Cleveland-Akron (Canton), OH"
          id="510"
        />
        <path
          className="white"
          d="M 677.79 232.33 680.61 226.98 674.88 229.06 670.3 223.68 668.88 228.01 659.92 221.21 659.3 223.08 654.34 220.09 653.9 217.19 654.11 215.17 651.54 215.92 657.82 204.4 665.77 202.94 667.72 193.86 671.97 195.08 669.83 202.18 682.57 199.73 681.51 201.56 685.01 203.7 684.57 207.07 692.86 212.15 693.85 216.62 696.47 216.83 703.95 231.54 695.76 231.04 687.66 227.76 682.88 233.83 677.79 232.33 Z"
          data-mrisynd="dma 511"
          data-state_name="Washington, DC (Hagerstown, MD)"
          id="511"
        />
        <path
          className="white"
          d="M 696.47 216.83 693.85 216.62 692.86 212.15 684.57 207.07 685.01 203.7 681.51 201.56 682.57 199.73 698.13 196.51 703.12 195.42 707.72 212.1 708.75 215.76 705.22 215.68 704.01 214.35 704.26 217.85 701.75 216.46 702.56 214.45 701.42 216.63 699.55 214.18 699.19 216.77 699.85 213.15 701.58 215.17 702.56 212.13 700.75 210.69 700.61 213.19 699.53 211 702.38 206.84 699.46 206.93 699.5 209.46 698.36 207.72 699.89 203.05 703.24 202.58 700.82 202.49 703.16 200.68 702.84 198.26 701.01 201.26 701.35 198.34 698.29 203.83 697.52 201.77 697.71 204.94 695.46 203.72 696.06 207.19 692.79 206.51 697.23 210.74 693.69 210.11 696.69 212.26 694.28 212.05 696.47 216.83 Z M 698.1 211.46 699.71 211.96 698.3 214 698.1 211.46 Z"
          data-mrisynd="dma 512"
          data-state_name="Baltimore, MD"
          fillRule="evenodd"
          id="512"
        />
        <path
          className="white"
          d="M 593.71 137.03 586.7 138.29 587.8 144.93 583.12 147.41 584.13 154.22 574.54 157.4 571.66 157.77 570.8 151.22 564.28 151.99 563.37 145.34 560.05 145.73 559.23 139.07 565.88 138.25 565.05 131.66 568.34 131.24 567.49 124.62 574.08 123.76 581.79 122.7 579.44 132.01 575.23 135.11 575.77 139.72 579.17 141.11 582.14 134.22 588.44 130.36 593.71 137.03 Z"
          data-mrisynd="dma 513"
          data-state_name="Flint-Saginaw-Bay City, MI"
          id="513"
        />
        <path
          className="white"
          d="M 658.05 132.67 660.55 138.92 660.18 148.63 665.09 148.9 666.45 157.95 668.41 157.55 670.26 166.21 665.03 168.54 661.49 166.4 650.87 168.25 650.11 161.03 638.31 163.11 637.41 157.95 648.29 145.93 643.73 137.36 658.05 132.67 Z"
          data-mrisynd="dma 514"
          data-state_name="Buffalo, NY"
          id="514"
        />
        <path
          className="white"
          d="M 574.59 243.6 571.04 239.68 572.94 238.03 571.39 236.06 568.93 237.72 568.42 233.44 564.84 233.86 564.31 228.4 566.27 226.77 565.67 221.82 569.51 221.36 569.12 217.73 572.3 217.13 572.64 220.19 579.78 218.91 589.43 218.45 591.02 221.6 594.23 221.19 594.86 227.4 596.65 227.93 597.73 235.64 592.42 234.98 592.42 238.08 587.38 240.75 580.94 238.74 574.59 243.6 Z"
          data-mrisynd="dma 515"
          data-state_name="Cincinnati, OH"
          id="515"
        />
        <path
          className="white"
          d="M 637.41 157.95 638.31 163.11 650.11 161.03 650.87 168.25 638.59 170.45 636.61 173.38 629.23 174.43 627.72 165.3 637.41 157.95 Z"
          data-mrisynd="dma 516"
          data-state_name="Erie, PA"
          id="516"
        />
        <path
          className="white"
          d="M 655.24 310.15 652.59 305.74 645.75 309.93 636.95 309.07 634.59 300.48 636.07 297.61 629.82 298.25 629.83 290.43 627.82 290.84 622.39 281.31 627.4 276 627.12 271.09 632.08 270.6 634.3 274.18 631.07 280.11 634.21 281.63 643.72 279.03 644.1 282.85 650.25 284.44 654.52 288.85 656.05 294.78 663.09 293.18 665.89 295.06 664.25 299.82 659.36 300.88 661.84 305.8 655.24 310.15 Z"
          data-mrisynd="dma 517"
          data-state_name="Charlotte, NC"
          id="517"
        />
        <path
          className="white"
          d="M 632.08 270.6 643.36 269.14 648 262.19 650.7 262.34 651.42 265.84 651.87 268.02 665.71 265.62 666.57 279.19 661.94 280.02 662.81 286.31 659.56 286.97 663.09 293.18 656.05 294.78 654.52 288.85 650.25 284.44 644.1 282.85 643.72 279.03 634.21 281.63 631.07 280.11 634.3 274.18 632.08 270.6 Z"
          data-mrisynd="dma 518"
          data-state_name="Greensboro-High Point-Winston Salem,"
          id="518"
        />
        <path
          className="white"
          d="M 657.53 346.03 646.92 337.73 650.96 334.14 655.14 330.39 659.19 330.41 663.25 318.24 671.67 318.15 678 321.78 676.55 329.2 674.27 327 675.68 330.97 665.89 339.01 665.54 342.87 657.53 346.03 Z"
          data-mrisynd="dma 519"
          data-state_name="Charleston, SC"
          id="519"
        />
        <path
          className="white"
          d="M 615.07 333.8 614.67 327.69 617.42 323.69 620.85 323.5 621.76 320.93 629.57 322.11 643.33 325.99 640.93 329.61 650.96 334.14 646.92 337.73 642.63 343.9 639.57 338.5 630.62 354.02 627.69 353.76 623.45 351.27 626.18 346.02 623.62 341.37 618.18 334.18 615.37 333.97 615.07 333.8 Z"
          data-mrisynd="dma 520"
          data-state_name="Augusta, GA"
          id="520"
        />
        <path
          className="white"
          d="M 751.5 152.12 749 139.03 758.45 134.77 760.78 140.49 764.06 142.62 760.07 147.19 758.97 143.06 757.63 143.92 755.38 140.06 756.58 149.99 751.5 152.12 Z"
          data-mrisynd="dma 521"
          data-state_name="Providence-New Bedford, RI-MA"
          id="521"
        />
        <path
          className="white"
          d="M 590.91 375.14 587.54 375.83 584.91 370.54 575.56 374.61 576.42 370.96 579.94 364.03 578.71 357.22 574.41 356.05 574.94 345.8 580.69 345.14 581.98 349.61 592.93 348.06 598.1 351.18 601.7 353.8 598.19 358.83 603.57 363.31 604.49 365.5 593.52 366.71 595.1 372.28 590.66 372.86 590.91 375.14 Z"
          data-mrisynd="dma 522"
          data-state_name="Columbus, GA"
          id="522"
        />
        <path
          className="white"
          d="M 702.14 108.93 695.73 92.69 738.29 81.88 737.86 87.2 739.94 89.92 737.78 94.09 745 98.9 745.56 101.83 742.96 102.96 744.03 105.24 738.59 113.13 740.29 118.9 729.1 119.22 722.93 119.56 721.9 115.05 719.3 115.03 718.98 110.71 710.11 114.09 705.53 111.6 705.45 107.74 702.14 108.93 Z"
          data-mrisynd="dma 523"
          data-state_name="Burlington-Plattsburgh, VT-NY"
          id="523"
        />
        <path
          className="white"
          d="M 617.42 323.69 614.67 327.69 615.07 333.8 611.01 340.19 599.44 341.05 598.1 351.18 592.93 348.06 581.98 349.61 580.69 345.14 574.94 345.8 573.99 345.92 573.32 338.42 569.48 339.21 573.08 335.48 572.62 331.11 576.2 329 573.21 318.46 572.86 317.23 586.51 315.76 586.09 307.93 595.67 306.76 599.4 303 603.18 305.62 609.66 304.73 605.44 315.37 607.72 320.08 611.39 318.62 617.42 323.69 Z"
          data-mrisynd="dma 524"
          data-state_name="Atlanta, GA"
          id="524"
        />
        <path
          className="white"
          d="M 594.36 379.41 594.27 378.21 590.91 375.14 590.66 372.86 595.1 372.28 593.52 366.71 604.49 365.5 603.57 363.31 609.25 362.62 609.65 365.96 622.28 364.98 622.65 367.75 626.04 367.24 627.08 371.06 626.63 376.67 608.71 382.15 596.4 382.67 596.07 379.27 594.36 379.41 Z"
          data-mrisynd="dma 525"
          data-state_name="Albany, GA"
          id="525"
        />
        <path
          className="white"
          d="M 695.58 120.64 693.58 110.89 697.97 110.45 701.52 121.19 700.88 124.22 703.23 124.77 704.35 132.89 706.07 133.17 706.54 139.23 697.67 145.26 697.55 136.78 696.43 130.88 694.05 129.04 695.58 120.64 Z"
          data-mrisynd="dma 526"
          data-state_name="Utica, NY"
          id="526"
        />
        <path
          className="white"
          d="M 553.16 194.48 553.97 201.16 561.05 200.35 564.81 201.61 565.13 206.65 571.13 205.88 571.71 211.77 566.04 212.44 566.92 217.98 569.12 217.73 569.51 221.36 565.67 221.82 566.27 226.77 564.31 228.4 551.67 232.62 552.53 239.56 546.97 240.15 546.06 230.9 540.57 231.38 540.28 228.01 541.91 227.87 539.97 217.84 533.55 216.65 533.7 213.35 537.79 208.32 538.13 211.26 543.89 210.7 543.66 208.19 543.23 204.01 537.44 204.55 537.09 201.2 539.18 197.57 553.16 194.48 Z"
          data-mrisynd="dma 527"
          data-state_name="Indianapolis, IN"
          id="527"
        />
        <path
          className="white"
          d="M 664.9 474.93 672.17 473.75 670.44 463.87 684.35 461.83 681.93 483.81 684.32 480.86 680 488.85 681.38 483.04 682 485.18 680.09 483.67 669.45 486.64 668.88 483.46 673.31 484.21 668.65 482.38 664.9 474.93 Z"
          data-mrisynd="dma 528"
          data-state_name="Miami-Ft. Lauderdale, FL"
          id="528"
        />
        <path
          className="white"
          d="M 547.29 243.23 546.97 240.15 552.53 239.56 551.67 232.62 564.31 228.4 564.84 233.86 568.42 233.44 568.93 237.72 571.39 236.06 572.94 238.03 571.04 239.68 574.59 243.6 570.93 251.03 573.77 253.48 572.52 264.24 574.63 266.42 572.35 271.77 568.98 271.9 564.91 267.6 564.84 262.93 558.95 264.22 550.5 264.94 548.75 257.37 551.91 251.49 547.83 248.31 547.29 243.23 Z"
          data-mrisynd="dma 529"
          data-state_name="Louisville, KY"
          id="529"
        />
        <path
          className="white"
          d="M 627.88 400.77 619.57 404.02 618.61 407.03 607.61 400.11 600.67 403.46 596.82 401.61 596.27 396.05 591.07 392.45 592.09 390.54 589.05 385.04 589.86 380.01 594.36 379.41 596.07 379.27 596.4 382.67 608.71 382.15 626.63 376.67 632.4 387.54 627.43 388.57 629.16 391.39 626.89 393.06 627.88 400.77 Z"
          data-mrisynd="dma 530"
          data-state_name="Tallahassee-Thomasville, FL-GA"
          id="530"
        />
        <path
          className="white"
          d="M 610.3 286.13 603.19 278.62 609.61 273.53 596.75 275.13 608.31 267.16 604.12 266.32 604.78 262.94 609.26 260.32 612 261.41 620.68 253.97 623 258.16 624.31 259.02 622.15 261.02 624.49 264.23 629.53 262.46 632.91 266.77 627.12 271.09 627.4 276 622.39 281.31 614.62 284 610.3 286.13 Z M 598.43 268.31 597.2 263.99 599.11 260.76 603.16 266.07 600.28 268.39 598.43 268.31 Z"
          data-mrisynd="dma 531"
          data-state_name="Tri-Cities, TN-VA"
          fillRule="evenodd"
          id="531"
        />
        <path
          className="white"
          d="M 731.55 142.8 725.51 144.08 711.64 144.99 710.31 144.64 711.18 141.52 706.54 139.23 706.07 133.17 704.35 132.89 703.23 124.77 700.88 124.22 701.52 121.19 697.97 110.45 702.14 108.93 705.45 107.74 705.53 111.6 710.11 114.09 718.98 110.71 719.3 115.03 721.9 115.05 722.93 119.56 729.1 119.22 727.33 122.37 730 129.26 728.73 129.54 730.18 137.45 731.55 142.8 Z"
          data-mrisynd="dma 532"
          data-state_name="Albany-Schenectady-Troy, NY"
          id="532"
        />
        <path
          className="white"
          d="M 734.76 159.34 734.79 156.76 726.82 151.4 725.51 144.08 731.55 142.8 744.26 139.8 749 139.03 751.5 152.12 736.99 156.24 734.76 159.34 Z"
          data-mrisynd="dma 533"
          data-state_name="Hartford &amp; New Haven, CT"
          id="533"
        />
        <path
          className="white"
          d="M 672.45 434.21 665.95 435.88 666.63 439.25 662.07 439.96 655.56 433.31 657.32 432.18 651.32 428.03 644.71 429.68 644.14 425.73 640.08 423.72 641.16 420.35 634.95 416.97 634.66 417 635.6 408.33 641.47 407.75 644.82 406.27 648.11 409.59 650.31 408.66 652.01 407.57 649.87 403.56 654.86 401.84 665.37 418.13 663.52 417.38 664.47 420.07 665.39 418.16 667.54 419.48 661.56 412.36 668.78 420.7 670 423.04 668.21 424.16 668.46 420.87 666.9 424.42 664.48 420.12 672.45 434.21 Z M 668.87 425.94 669.03 424.04 673.02 434.08 668.87 425.94 Z"
          data-mrisynd="dma 534"
          data-state_name="Orlando-Daytona Beach-Melbourne, FL"
          fillRule="evenodd"
          id="534"
        />
        <path
          className="white"
          d="M 621.47 200.88 623.21 201.47 623.75 205.67 617.41 208.77 616.19 202.89 609.34 203.64 609.38 208.59 612.05 210.89 617.61 210.45 619.69 213.44 616.35 216.64 618.43 221.61 610.86 222.27 610.05 218.85 606.73 219.1 603.37 220.13 603.65 228.3 596.65 227.93 594.86 227.4 594.23 221.19 591.02 221.6 589.43 218.45 590.63 209.29 589.19 199.73 583.94 199.98 583.67 197.82 583.23 194.45 594.57 195.24 593.79 189.66 597.84 189.05 599.33 188.86 601.99 197.19 615.44 197.27 617.33 201.24 621.47 200.88 Z"
          data-mrisynd="dma 535"
          data-state_name="Columbus, OH"
          id="535"
        />
        <path
          className="white"
          d="M 631.94 190.87 628.98 192.44 627.15 192.42 623.52 190.48 622.38 175.5 629.23 174.43 636.61 173.38 636.83 174.66 636.59 181.64 630.41 181.58 631.94 190.87 Z"
          data-mrisynd="dma 536"
          data-state_name="Youngstown, OH"
          id="536"
        />
        <path
          className="white"
          d="M 774.89 87 768.06 87.1 768.76 82.85 766.54 80.01 764.5 80.94 765.51 83.13 761.05 83.72 755.35 74.97 751.87 75.6 747.45 66.39 750.12 61.23 748.15 55.77 749.62 47.67 765.01 43.36 765.98 46.6 770.97 45.4 775.44 60.14 782.96 55.84 788.36 56.12 789.31 61.92 792.06 64.19 794.25 62.87 798 66.65 794.74 67.25 796.23 69.64 797.01 67.07 799 68.29 796.07 73 791.75 73.65 792.58 76 790.84 77.25 788.9 75.37 787.22 81.66 783.76 77.68 782.12 81.89 780.46 80.44 781.66 85.43 777.2 85.05 776.16 80.36 774.89 87 Z M 784.08 83.33 782.43 83.54 784.16 80.55 785.73 82.19 784.08 83.33 Z M 779.38 87.12 778.43 84.76 781.32 86.22 779.38 87.12 Z"
          data-mrisynd="dma 537"
          data-state_name="Bangor, ME"
          fillRule="evenodd"
          id="537"
        />
        <path
          className="white"
          d="M 675.57 129.63 676.93 135.64 673.53 136.56 676.28 145.28 672.72 145.78 665.56 146.66 665.09 148.9 660.18 148.63 660.55 138.92 658.05 132.67 673.27 132.65 675.57 129.63 Z"
          data-mrisynd="dma 538"
          data-state_name="Rochester, NY"
          id="538"
        />
        <path
          className="white"
          d="M 662.07 439.96 661.45 443.02 666.75 447.57 656.7 452.56 655.8 446.77 647.43 448.08 648.26 453.85 643.41 456.22 643.14 456.26 643.06 456.25 636.22 447.06 640.5 440.86 639.66 437.36 637.96 439.92 634.65 436.46 637.01 439.15 635.88 442.88 632.53 439.95 634.17 426.71 633.48 420.35 631.09 418.34 634.66 417 634.95 416.97 641.16 420.35 640.08 423.72 644.14 425.73 644.71 429.68 651.32 428.03 657.32 432.18 655.56 433.31 662.07 439.96 Z"
          data-mrisynd="dma 539"
          data-state_name="Tampa-St.Petersburg (Sarasota), FL"
          id="539"
        />
        <path
          className="white"
          d="M 579.08 109.55 572.44 110.52 574.08 123.76 567.49 124.62 568.34 131.24 565.05 131.66 565.88 138.25 559.23 139.07 560.05 145.73 553.41 146.2 552.7 139.77 540.72 140.95 539.1 136.5 541.93 130.61 541.42 123.99 549.92 113.03 549.3 120.1 550.25 121.58 551.4 117.12 551.24 121.85 552.21 111.6 558.09 108.56 555.06 106.06 555.96 101.67 566.92 102.83 579.08 109.55 Z M 544.11 99.03 542.65 85.28 554.49 82.37 554.07 87.9 563.69 86.71 565.16 92.59 570.3 95.52 560.04 95.6 559.62 99.81 549.8 95.82 544.11 99.03 Z M 571.99 96.31 570.57 95.53 572.41 93.1 575.97 94.87 571.99 96.31 Z M 548.12 105.64 549.43 102.59 550.06 105.31 548.12 105.64 Z M 565.09 85.82 566.62 89.58 564 87.01 565.09 85.82 Z"
          data-mrisynd="dma 540"
          data-state_name="Traverse City-Cadillac, MI"
          fillRule="evenodd"
          id="540"
        />
        <path
          className="white"
          d="M 609.26 260.32 604.78 262.94 604.12 266.32 603.16 266.07 599.11 260.76 597.2 263.99 598.43 268.31 592.91 275.88 588.37 276.37 585.36 269.51 579.85 277.18 576.54 277.14 575.04 272.76 572.35 271.77 574.63 266.42 572.52 264.24 573.77 253.48 570.93 251.03 574.59 243.6 580.94 238.74 587.38 240.75 592.42 238.08 597.41 241.47 599.9 244.05 599.17 246.3 603.61 247.6 605.77 256.72 609.26 260.32 Z"
          data-mrisynd="dma 541"
          data-state_name="Lexington, KY"
          id="541"
        />
        <path
          className="white"
          d="M 569.12 217.73 566.92 217.98 566.04 212.44 571.71 211.77 571.13 205.88 570.19 197.84 576.13 197.97 583.67 197.82 583.94 199.98 589.19 199.73 590.63 209.29 589.43 218.45 579.78 218.91 572.64 220.19 572.3 217.13 569.12 217.73 Z"
          data-mrisynd="dma 542"
          data-state_name="Dayton, OH"
          id="542"
        />
        <path
          className="white"
          d="M 730 129.26 738.92 127.37 740.3 134.56 744.26 139.8 731.55 142.8 730.18 137.45 728.73 129.54 730 129.26 Z"
          data-mrisynd="dma 543"
          data-state_name="Springfield-Holyoke, MA"
          id="543"
        />
        <path
          className="white"
          d="M 703.14 264.3 694.96 267.44 684.37 262.1 693.46 260.32 689.9 258.53 697.07 251.68 693.41 249.09 697.05 246.18 696.09 242.22 699.43 241.05 698.97 238.26 703.7 238.78 705.76 242.65 703.96 240.32 701.97 241.38 704.25 243.33 702.61 244.61 703.86 246.53 706.73 246.86 705.18 250.26 711.54 249.17 723.04 269.35 714.99 256.21 711.93 255.1 717.98 264.58 713.02 259.88 715.83 263.21 710.66 261.6 713.65 264.04 707.44 264.21 710.18 265.73 707.37 268.13 704.55 267.71 703.87 263.38 701.75 262.28 703.26 264.27 703.17 264.29 703.14 264.3 Z M 712.63 227.63 716.15 226.44 711.08 245.36 709.54 241.49 711.34 236.37 709.7 236.76 712.63 227.63 Z M 718.23 272.96 716.29 272.92 717.41 266.59 720.72 271.48 720.37 273.81 718.23 272.96 Z M 722.25 281.14 722.2 281.04 725.45 278.89 723.28 269.31 725.49 279.71 722.25 281.14 Z M 717.96 225.81 718.09 225.77 716.23 229.19 717.96 225.81 Z"
          data-mrisynd="dma 544"
          data-state_name="Norfolk-Portsmouth-Newport News, VA"
          fillRule="evenodd"
          id="544"
        />
        <path
          className="white"
          d="M 698.01 300.92 697.83 300.77 699.77 299.15 697.66 300.63 694.45 296.1 687.77 297.35 685.3 288.63 690.4 287.88 689.11 280.35 695.39 274.26 693.83 271.02 696.14 268.42 694.96 267.44 703.14 264.3 704.49 270.09 714.25 266.98 714.53 273.07 716.29 272.92 718.23 272.96 715.53 279.87 709.46 279.64 708.21 277.77 710.09 276.48 707.52 277.73 708.86 280.03 700.85 278.58 710.9 281.73 706.89 285.26 710.38 284.42 707.04 288.78 701.88 285.86 704.24 288.62 711.46 289.51 711.78 285.59 712.88 288.78 714.77 288.38 712.41 292.55 708.93 291.67 703.71 295.22 702.4 293.52 700.71 298.31 698.13 294.78 700.41 298.77 698.01 300.92 Z"
          data-mrisynd="dma 545"
          data-state_name="Greenville-New Bern-Washington, NC"
          id="545"
        />
        <path
          className="white"
          d="M 663.25 318.24 659.19 330.41 655.14 330.39 650.96 334.14 640.93 329.61 643.33 325.99 629.57 322.11 630.37 315.38 636.95 309.07 645.75 309.93 652.59 305.74 655.24 310.15 663.25 318.24 Z"
          data-mrisynd="dma 546"
          data-state_name="Columbia, SC"
          id="546"
        />
        <path
          className="white"
          d="M 595.63 180.88 597.84 189.05 593.79 189.66 594.57 195.24 583.23 194.45 582.36 187.76 580.72 187.99 575.79 188.64 568.99 187.76 567.94 179.24 574.23 178.27 573.33 171.23 576.61 170.86 581.62 170.02 582.67 176.88 586.62 176.19 586.65 176.19 586.81 176.17 586.87 176.16 587.01 176.14 598.06 178.45 593.58 180.57 595.63 180.88 Z"
          data-mrisynd="dma 547"
          data-state_name="Toledo, OH"
          id="547"
        />
        <path
          className="white"
          d="M 684.35 461.83 670.44 463.87 666.75 447.57 661.45 443.02 662.07 439.96 666.63 439.25 665.95 435.88 672.45 434.21 679.7 446.15 677.2 445.31 683.11 451.63 684.35 461.83 Z M 679.05 444.4 676.63 441.13 680.3 446.15 679.05 444.4 Z"
          data-mrisynd="dma 548"
          data-state_name="West Palm Beach-Ft. Pierce, FL"
          fillRule="evenodd"
          id="548"
        />
        <path
          className="white"
          d="M 695.73 92.69 702.14 108.93 697.97 110.45 693.58 110.89 695.58 120.64 691.48 124.74 688.25 124.45 687.1 120.38 681.58 121.75 681.38 121.77 681.35 121.78 679.34 118.74 681.98 115.42 680.2 116.34 679.71 114.24 679.14 116.72 677.42 114.11 688.65 97.39 695.73 92.69 Z"
          data-mrisynd="dma 549"
          data-state_name="Watertown, NY"
          id="549"
        />
        <path
          className="white"
          d="M 675.21 297.48 681.4 295.93 686.19 300.98 687.77 297.35 694.45 296.1 697.66 300.63 693.39 311.91 693.2 310.06 683.89 314.92 674.41 308.15 677.23 303.55 675.21 297.48 Z M 697.83 300.77 698.01 300.92 696.24 303.08 697.83 300.77 Z"
          data-mrisynd="dma 550"
          data-state_name="Wilmington, NC"
          fillRule="evenodd"
          id="550"
        />
        <path
          className="white"
          d="M 564.28 151.99 570.8 151.22 571.66 157.77 574.54 157.4 576.61 170.86 573.33 171.23 574.23 178.27 567.94 179.24 567.52 178.05 567.52 165.15 562.56 165.75 562.08 162.1 561.75 159.05 565.07 158.67 564.28 151.99 Z"
          data-mrisynd="dma 551"
          data-state_name="Lansing, MI"
          id="551"
        />
        <path
          className="white"
          d="M 782.96 55.84 775.44 60.14 770.97 45.4 765.98 46.6 765.01 43.36 749.62 47.67 755.15 28.56 757.6 28.48 758.43 31.64 760.73 32.53 769.31 27.03 775.4 30.38 782.96 55.84 Z"
          data-mrisynd="dma 552"
          data-state_name="Presque Isle, ME"
          id="552"
        />
        <path
          className="white"
          d="M 526.16 108.88 524.02 100.69 520.68 100.98 520.05 106.1 510.27 106.93 506.9 107.18 506.36 101.62 502.14 100.34 501.81 95.82 491.58 93.23 489.3 88.39 496.32 86.04 507.82 75.42 513.95 72.83 517.06 73.98 510.6 78.49 507.74 87.25 512.07 82.85 510.4 85.77 516.5 83.94 523.21 90.78 532.91 91.64 542.65 85.28 544.11 99.03 538.69 100.09 534.81 107.08 533.26 105.74 535.31 101.52 529.95 106.26 529.4 101.53 526.16 108.88 Z M 496.6 66.24 506.53 59.89 499.41 66 500.62 66.03 496.6 66.24 Z"
          data-mrisynd="dma 553"
          data-state_name="Marquette, MI"
          fillRule="evenodd"
          id="553"
        />
        <path
          className="white"
          d="M 631.94 190.87 634.82 208.41 636.88 209.72 635.62 213.98 628.85 216.65 627.07 214.73 627.77 212.48 619.69 213.44 617.61 210.45 617.41 208.77 623.75 205.67 623.21 201.47 621.47 200.88 621.79 196.52 626.53 195.95 627.15 192.42 628.98 192.44 631.94 190.87 Z"
          data-mrisynd="dma 554"
          data-state_name="Wheeling-Steubenville, WV-OH"
          id="554"
        />
        <path
          className="white"
          d="M 682.25 149.19 680.12 149.58 679.02 144.63 676.28 145.28 673.53 136.56 676.93 135.64 675.57 129.63 681.53 124.68 681.58 121.75 687.1 120.38 688.25 124.45 691.48 124.74 695.58 120.64 694.05 129.04 696.43 130.88 697.55 136.78 689.45 138.94 691.06 144.68 685.15 146.22 686.19 148.07 682.25 149.19 Z"
          data-mrisynd="dma 555"
          data-state_name="Syracuse, NY"
          id="555"
        />
        <path
          className="white"
          d="M 703.95 231.54 703.7 238.78 698.97 238.26 699.43 241.05 696.09 242.22 697.05 246.18 693.41 249.09 697.07 251.68 689.9 258.53 693.46 260.32 684.37 262.1 682.17 262.52 681.61 258.02 674.21 257.19 674.28 253.46 670.1 251.78 670.88 247.8 666.67 244.84 668.97 241.57 675.2 241.2 676.97 236.68 673 235.43 674 232.74 677.79 232.33 682.88 233.83 687.66 227.76 695.76 231.04 703.95 231.54 Z"
          data-mrisynd="dma 556"
          data-state_name="Richmond-Petersburg, VA"
          id="556"
        />
        <path
          className="white"
          d="M 603.16 266.07 604.12 266.32 608.31 267.16 596.75 275.13 609.61 273.53 603.19 278.62 610.3 286.13 609.32 289.6 596.3 296.31 594.56 300.95 587.35 301.99 588.69 300.67 586.14 295.57 581.68 292.15 574.55 294.12 575.47 279.7 580.85 278.59 579.85 277.18 585.36 269.51 588.37 276.37 592.91 275.88 598.43 268.31 600.28 268.39 603.16 266.07 Z"
          data-mrisynd="dma 557"
          data-state_name="Knoxville, TN"
          id="557"
        />
        <path
          className="white"
          d="M 583.23 194.45 583.67 197.82 576.13 197.97 575.79 188.64 580.72 187.99 582.36 187.76 583.23 194.45 Z"
          data-mrisynd="dma 558"
          data-state_name="Lima, OH"
          id="558"
        />
        <path
          className="white"
          d="M 620.68 253.97 622.46 248.9 626.06 247.69 624.96 244.65 627.51 243.96 628.86 237.99 637.12 240.27 640.61 236.02 648.17 229.16 648.8 225.34 651.27 226.41 651.19 227.85 644.53 246.66 645.06 250.19 636.94 253.06 629.53 262.46 624.49 264.23 622.15 261.02 624.31 259.02 623 258.16 620.68 253.97 Z"
          data-mrisynd="dma 559"
          data-state_name="Bluefield-Beckley-Oak Hill, WV"
          id="559"
        />
        <path
          className="white"
          d="M 687.77 297.35 686.19 300.98 681.4 295.93 675.21 297.48 672.73 295.59 668.29 298.66 665.89 295.06 663.09 293.18 659.56 286.97 662.81 286.31 661.94 280.02 666.57 279.19 665.71 265.62 674.3 262.39 672.55 261.3 674.21 257.19 681.61 258.02 682.17 262.52 684.37 262.1 694.96 267.44 696.14 268.42 693.83 271.02 695.39 274.26 689.11 280.35 690.4 287.88 685.3 288.63 687.77 297.35 Z"
          data-mrisynd="dma 560"
          data-state_name="Raleigh-Durham (Fayetteville), NC"
          id="560"
        />
        <path
          className="white"
          d="M 627.88 400.77 626.89 393.06 629.16 391.39 627.43 388.57 632.4 387.54 626.63 376.67 627.08 371.06 632.91 369.02 641.62 371.68 642.9 369.04 646.97 371.54 646.18 380.72 654.86 401.84 649.87 403.56 652.01 407.57 650.31 408.66 648.11 409.59 644.82 406.27 641.47 407.75 639.16 401.01 627.88 400.77 Z M 648.94 372.74 647.22 374.47 647.18 371.09 648.94 372.74 Z"
          data-mrisynd="dma 561"
          data-state_name="Jacksonville, FL"
          fillRule="evenodd"
          id="561"
        />
        <path
          className="white"
          d="M 560.05 145.73 563.37 145.34 564.28 151.99 565.07 158.67 561.75 159.05 562.08 162.1 562.56 165.75 567.52 165.15 567.52 178.05 562.25 178.66 553.81 179.62 553.57 173.6 547.06 174.26 546.71 170.95 544.72 171.15 545.67 159.08 539.63 144.98 540.72 140.95 552.7 139.77 553.41 146.2 560.05 145.73 Z"
          data-mrisynd="dma 563"
          data-state_name="Grand Rapids-Kalamazoo-Battle Creek,"
          id="563"
        />
        <path
          className="white"
          d="M 592.42 238.08 592.42 234.98 597.73 235.64 596.65 227.93 603.65 228.3 603.37 220.13 606.73 219.1 610.05 218.85 610.86 222.27 618.43 221.61 621.44 224.17 625.11 220.49 626.27 223.26 629.5 223.2 631.12 228.71 635.22 224.62 638.28 225.28 636.3 232.08 640.61 236.02 637.12 240.27 628.86 237.99 627.51 243.96 624.96 244.65 626.06 247.69 622.46 248.9 620.68 253.97 612 261.41 609.26 260.32 605.77 256.72 603.61 247.6 599.17 246.3 599.9 244.05 597.41 241.47 592.42 238.08 Z"
          data-mrisynd="dma 564"
          data-state_name="Charleston-Huntington, WV"
          id="564"
        />
        <path
          className="white"
          d="M 676.28 145.28 679.02 144.63 680.12 149.58 682.25 149.19 683.08 154.57 677.94 155.61 679.21 164.23 670.26 166.21 668.41 157.55 666.45 157.95 665.09 148.9 665.56 146.66 672.72 145.78 676.28 145.28 Z"
          data-mrisynd="dma 565"
          data-state_name="Elmira (Corning), NY"
          id="565"
        />
        <path
          className="white"
          d="M 698.13 196.51 682.57 199.73 669.83 202.18 671.97 195.08 673.55 190.79 670.04 188.81 670.51 185.71 676.21 178.74 676.88 181.48 686.32 180.44 690.68 182.73 700.21 187.82 698.55 195.98 698.13 196.51 Z"
          data-mrisynd="dma 566"
          data-state_name="Harrisburg-Lancaster-Lebanon-York, P"
          id="566"
        />
        <path
          className="white"
          d="M 622.39 281.31 627.82 290.84 629.83 290.43 629.82 298.25 636.07 297.61 634.59 300.48 636.95 309.07 630.37 315.38 629.57 322.11 621.76 320.93 620.85 323.5 617.42 323.69 611.39 318.62 607.72 320.08 605.44 315.37 609.66 304.73 603.18 305.62 599.4 303 599.1 301.3 594.56 300.95 596.3 296.31 609.32 289.6 610.3 286.13 614.62 284 622.39 281.31 Z"
          data-mrisynd="dma 567"
          data-state_name="Greenville-Spartanburg-Asheville-And"
          id="567"
        />
        <path
          className="white"
          d="M 651.19 227.85 651.27 226.41 654.34 220.09 659.3 223.08 659.92 221.21 668.88 228.01 667.54 230.52 664.98 236.1 660.97 239.95 655.33 237.08 656.75 230.41 651.19 227.85 Z"
          data-mrisynd="dma 569"
          data-state_name="Harrisonburg, VA"
          id="569"
        />
        <path
          className="white"
          d="M 678 321.78 671.67 318.15 663.25 318.24 655.24 310.15 661.84 305.8 659.36 300.88 664.25 299.82 665.89 295.06 668.29 298.66 672.73 295.59 675.21 297.48 677.23 303.55 674.41 308.15 683.89 314.92 683.92 314.93 684.05 315.03 678 321.78 Z"
          data-mrisynd="dma 570"
          data-state_name="Myrtle Beach-Florence, SC"
          id="570"
        />
        <path
          className="white"
          d="M 643.41 456.22 648.26 453.85 647.43 448.08 655.8 446.77 656.7 452.56 666.75 447.57 670.44 463.87 672.17 473.75 664.9 474.93 664.68 474.97 664.03 475.09 656.7 472.91 653.38 464.38 650.57 464.05 653.97 459.24 650.1 463.29 648.39 455.37 645.88 455.62 647.16 458.84 643.41 456.22 Z"
          data-mrisynd="dma 571"
          data-state_name="Ft. Myers-Naples, FL"
          id="571"
        />
        <path
          className="white"
          d="M 632.08 270.6 627.12 271.09 632.91 266.77 629.53 262.46 636.94 253.06 645.06 250.19 644.53 246.66 651.19 227.85 656.75 230.41 655.33 237.08 660.97 239.95 664.98 236.1 668.97 241.57 666.67 244.84 670.88 247.8 670.1 251.78 674.28 253.46 674.21 257.19 672.55 261.3 674.3 262.39 665.71 265.62 651.87 268.02 651.42 265.84 650.7 262.34 648 262.19 643.36 269.14 632.08 270.6 Z"
          data-mrisynd="dma 573"
          data-state_name="Roanoke-Lynchburg, VA"
          id="573"
        />
        <path
          className="white"
          d="M 650.87 168.25 661.49 166.4 665.03 168.54 665.5 174.79 667.13 172.52 673.71 176.96 678.56 174.39 676.21 178.74 670.51 185.71 670.04 188.81 673.55 190.79 671.97 195.08 667.72 193.86 665.77 202.94 657.82 204.4 655.18 204.9 651.15 205.63 650.33 203.17 656.26 185.12 655.51 181.52 649.65 182.48 648.32 174.45 651.48 171.81 650.87 168.25 Z"
          data-mrisynd="dma 574"
          data-state_name="Johnstown-Altoona, PA"
          id="574"
        />
        <path
          className="white"
          d="M 599.4 303 595.67 306.76 586.09 307.93 586.51 315.76 572.86 317.23 570.79 309.76 566.72 310.13 565.33 299.98 571.85 298.69 574.55 294.12 581.68 292.15 586.14 295.57 588.69 300.67 587.35 301.99 594.56 300.95 599.1 301.3 599.4 303 Z"
          data-mrisynd="dma 575"
          data-state_name="Chattanooga, TN"
          id="575"
        />
        <path
          className="white"
          d="M 705.22 215.68 708.75 215.76 707.72 212.1 713.22 208.61 717.02 210.62 718.27 214.19 716.41 212.71 717.67 214.15 715.03 215.21 718.31 214.2 719.14 217.25 719.12 219.64 718.76 216.09 717.14 217.98 718.97 219.57 716.15 226.44 712.63 227.63 708.65 228.89 710.44 226.24 707.05 225.22 709.41 222.54 707.16 223.46 707.74 219 705.7 224.7 700.28 220.75 703.12 219.08 700.34 217.71 704.54 218.29 705.22 215.68 Z M 718.09 225.77 717.96 225.81 719.1 219.68 718.09 225.77 Z"
          data-mrisynd="dma 576"
          data-state_name="Salisbury, MD"
          fillRule="evenodd"
          id="576"
        />
        <path
          className="white"
          d="M 707.45 169.77 690.68 182.73 686.32 180.44 676.88 181.48 676.21 178.74 678.56 174.39 673.71 176.96 667.13 172.52 665.5 174.79 665.03 168.54 670.26 166.21 679.21 164.23 677.94 155.61 683.08 154.57 699.76 151.02 703.36 153.18 704.55 154.52 705.77 157.27 702.96 165.38 706.15 164.41 706.16 166.43 709.06 166.89 707.45 169.77 Z"
          data-mrisynd="dma 577"
          data-state_name="Wilkes Barre-Scranton, PA"
          id="577"
        />
        <path
          className="white"
          d="M 521.69 238.04 521.3 233.01 524.12 232.76 526.51 232.53 525.91 226.61 533.02 226.07 531.86 213.12 533.7 213.35 533.55 216.65 539.97 217.84 541.91 227.87 540.28 228.01 540.57 231.38 546.06 230.9 546.97 240.15 547.29 243.23 543.27 244.27 536.21 244 531.68 246.86 532.8 243.77 523.79 243.92 523.49 241.1 521.69 238.04 Z"
          data-mrisynd="dma 581"
          data-state_name="Terre Haute, IN"
          id="581"
        />
        <path
          className="white"
          d="M 533.7 213.35 531.86 213.12 530.92 201.75 537.09 201.2 537.44 204.55 543.23 204.01 543.66 208.19 543.89 210.7 538.13 211.26 537.79 208.32 533.7 213.35 Z"
          data-mrisynd="dma 582"
          data-state_name="Lafayette, IN"
          id="582"
        />
        <path
          className="white"
          d="M 581.79 122.7 574.08 123.76 572.44 110.52 579.08 109.55 581.27 112.8 578.57 113.57 580.93 115.6 581.79 122.7 Z"
          data-mrisynd="dma 583"
          data-state_name="Alpena, MI"
          id="583"
        />
        <path
          className="white"
          d="M 668.88 228.01 670.3 223.68 674.88 229.06 680.61 226.98 677.79 232.33 674 232.74 673 235.43 676.97 236.68 675.2 241.2 668.97 241.57 664.98 236.1 667.54 230.52 668.88 228.01 Z"
          data-mrisynd="dma 584"
          data-state_name="Charlottesville, VA"
          id="584"
        />
        <path
          className="white"
          d="M 553.16 194.48 539.18 197.57 538.6 191.32 544.3 184.28 543.4 180.68 539.12 181.1 544.72 171.15 546.71 170.95 547.06 174.26 553.57 173.6 553.81 179.62 562.25 178.66 562.76 182.74 556.24 183.93 556.83 193.16 553.16 194.48 Z"
          data-mrisynd="dma 588"
          data-state_name="South Bend-Elkhart, IN"
          id="588"
        />
        <path
          className="white"
          d="M 618.61 407.03 619.57 404.02 627.88 400.77 639.16 401.01 641.47 407.75 635.6 408.33 634.66 417 631.09 418.34 629.84 415.31 625.67 415.75 619.08 409.99 618.61 407.03 Z"
          data-mrisynd="dma 592"
          data-state_name="Gainesville, FL"
          id="592"
        />
        <path
          className="white"
          d="M 617.41 208.77 617.61 210.45 612.05 210.89 609.38 208.59 609.34 203.64 616.19 202.89 617.41 208.77 Z"
          data-mrisynd="dma 596"
          data-state_name="Zanesville, OH"
          id="596"
        />
        <path
          className="white"
          d="M 628.85 216.65 625.11 220.49 621.44 224.17 618.43 221.61 616.35 216.64 619.69 213.44 627.77 212.48 627.07 214.73 628.85 216.65 Z"
          data-mrisynd="dma 597"
          data-state_name="Parkersburg, WV"
          id="597"
        />
        <path
          className="white"
          d="M 654.34 220.09 651.27 226.41 648.8 225.34 648.17 229.16 640.61 236.02 636.3 232.08 638.28 225.28 635.22 224.62 631.12 228.71 629.5 223.2 626.27 223.26 625.11 220.49 628.85 216.65 635.62 213.98 636.88 209.72 644.81 212.35 646.08 215.86 651.54 215.92 654.11 215.17 653.9 217.19 654.34 220.09 Z"
          data-mrisynd="dma 598"
          data-state_name="Clarksburg-Weston, WV"
          id="598"
        />
        <path
          className="white"
          d="M 383.18 479.5 373.83 479.03 373.9 475.89 357.12 475.37 357.39 466.16 360.09 466.28 360.45 451.21 368.45 451.43 368.69 440.83 372.79 437.59 383.7 445.14 388.59 442.33 390.46 442.5 393.16 443.25 394.95 444.41 394.7 447.68 394.49 448.76 388.11 449.8 387.93 453.47 390.88 450.95 387.91 456.26 381.68 455.25 386.97 458.81 383.99 465.75 381.68 466.43 382.6 462.95 380.54 466.43 377.85 463.17 379.8 466.03 377.68 466.5 383.76 466.9 380.82 474.73 383.18 479.5 Z M 385.93 479.54 385.87 479.54 384.32 468.02 388.06 458.84 384.58 469.32 385.93 479.54 Z M 392.23 452.88 393.59 451.8 390.4 455.99 392.23 452.88 Z M 385.72 479.54 385.58 479.54 384.9 477.73 385.72 479.54 Z"
          data-mrisynd="dma 600"
          data-state_name="Corpus Christi, TX"
          fillRule="evenodd"
          id="600"
        />
        <path
          className="white"
          d="M 539.12 181.1 543.4 180.68 544.3 184.28 538.6 191.32 539.18 197.57 537.09 201.2 530.92 201.75 530.45 196.48 520.1 197.67 519.85 195.36 510.1 196.29 510.35 199.73 508.67 199.89 506.47 192.59 506.04 187.28 509.24 186.21 508.47 176.11 511.78 175.82 511.25 169.28 524.02 168.26 524.01 172.6 529.57 183.31 532.29 184.67 539.12 181.1 Z"
          data-mrisynd="dma 602"
          data-state_name="Chicago, IL"
          id="602"
        />
        <path
          className="white"
          d="M 437.81 289.04 429.51 289.17 429.46 285.91 423.61 285.93 423.42 279.56 415.57 279.62 415.55 272.17 408.87 272.14 408.9 259.48 415.52 259.49 437.5 259.25 437.81 289.04 Z"
          data-mrisynd="dma 603"
          data-state_name="Joplin-Pittsburg, MO-KS"
          id="603"
        />
        <path
          className="white"
          d="M 475.68 233.08 476.28 236.46 478.48 236.4 478.69 242.16 473.25 245.12 473.95 257.75 468.14 258.79 460.69 258.86 458.69 255.24 454.3 255.35 452.09 254.53 452.09 249.3 452.11 240.72 454.91 235.64 448.47 231.41 448.17 227.06 454.47 226.54 462.73 228.09 462.78 233.08 475.68 233.08 Z"
          data-mrisynd="dma 604"
          data-state_name="Columbia-Jefferson City, MO"
          id="604"
        />
        <path
          className="white"
          d="M 415.52 259.49 408.9 259.48 408.9 256.93 402.92 256.89 403 250.12 394.39 250.06 394.01 238.23 387.96 238.16 388.04 234.79 379.76 234.65 379.83 229.59 388.15 228.05 388.23 221.31 408.13 221.48 417.95 221.46 418 228.19 414.7 228.21 414.63 232.74 420.4 232.7 420.34 239.96 415.7 239.77 415.52 259.49 Z"
          data-mrisynd="dma 605"
          data-state_name="Topeka, KS"
          id="605"
        />
        <path
          className="white"
          d="M 594.36 379.41 589.86 380.01 589.05 385.04 569.66 387.31 569.09 375.31 575.56 374.61 584.91 370.54 587.54 375.83 590.91 375.14 594.27 378.21 594.36 379.41 Z"
          data-mrisynd="dma 606"
          data-state_name="Dothan, AL"
          id="606"
        />
        <path
          className="white"
          d="M 523.79 243.92 517.15 244.33 517.35 246.86 510.7 247.38 511.02 252.43 504.35 252.77 503.67 260.88 500.97 259.07 496.75 264.48 490.88 264.78 491.06 271.97 488.25 272.16 487.82 276.46 484.15 275.79 479.25 268.08 481.49 264.24 471.56 262.9 471.67 266.62 468.35 266.7 468.14 258.79 473.95 257.75 473.25 245.12 478.69 242.16 478.48 236.4 476.28 236.46 475.68 233.08 475.24 230.54 478.87 227.49 483.01 231.14 492.22 228.27 503.51 227.46 503.78 230.85 514.67 232.66 515.09 238.54 521.69 238.04 523.49 241.1 523.79 243.92 Z"
          data-mrisynd="dma 609"
          data-state_name="St. Louis, MO"
          id="609"
        />
        <path
          className="white"
          d="M 494.05 170.25 506.24 169.6 510.28 169.39 511.25 169.28 511.78 175.82 508.47 176.11 509.24 186.21 506.04 187.28 499.4 187.74 497.79 175.95 494.52 176.22 494.05 170.25 Z"
          data-mrisynd="dma 610"
          data-state_name="Rockford, IL"
          id="610"
        />
        <path
          className="white"
          d="M 436.55 153.5 441.03 153.39 440.86 146.68 449.22 146.43 449 139.71 462.4 140.96 462.6 145.98 467.44 145.77 467.74 152.45 462.87 152.66 463.08 158.2 456.47 158.46 456.68 164.36 450.07 164.57 436.78 164.92 436.55 153.5 Z"
          data-mrisynd="dma 611"
          data-state_name="Rochester-Mason City-Austin, MN-IA"
          id="611"
        />
        <path
          className="white"
          d="M 422.26 349.41 428.23 350.72 428.47 342.91 421.69 338.84 421.71 332.91 425.03 327.8 432.54 327.68 432.49 333.82 436.07 333.7 435.85 330.57 440.89 330.57 442.81 337.13 448.65 337.9 448.48 347.84 456.59 348.95 456.66 355.89 460.89 355.84 461.05 360.73 458.64 363.9 460.62 370.87 457.99 372.62 457.7 381.1 461.97 384.64 458.36 388.05 451.08 387.93 448.51 391.44 447.73 391.63 445.73 385.2 434.4 382.68 431.07 376.62 432.71 368.49 429.3 368 429.66 360 425.49 355.54 422.31 356.27 422.26 349.41 Z"
          data-mrisynd="dma 612"
          data-state_name="Shreveport, LA"
          id="612"
        />
        <path
          className="white"
          d="M 424.23 153.67 416.82 153.75 415.7 140.34 407.2 140.35 407.01 131.99 402.1 131.97 402.13 119.08 396.71 113.18 400.72 106.89 404.72 103.58 419.73 103.56 418.8 69.78 418.32 66.97 413.59 67 413.41 57.13 418.46 57.06 418.5 60.39 428.62 60.23 429.16 78 433.28 77.11 437.56 80.32 437.67 85.58 447.18 85.39 447.56 97.02 457.72 96.7 457.9 101.68 467.83 101.26 468.44 111.21 467.8 129.61 461.18 129.88 461.28 132.66 458.8 132.74 464.43 136.71 465.38 139.17 462.4 140.96 449 139.71 449.22 146.43 440.86 146.68 441.03 153.39 436.55 153.5 432.68 153.56 432.57 146.85 439.22 146.72 439.04 139.17 431.11 138.97 423.86 134.44 423.89 138.6 420.58 138.66 420.71 142 424.02 141.97 424.23 153.67 Z"
          data-mrisynd="dma 613"
          data-state_name="Minneapolis-St. Paul, MN"
          id="613"
        />
        <path
          className="white"
          d="M 446.41 209.73 446.82 220.31 454.41 220.01 454.47 226.54 448.17 227.06 448.47 231.41 454.91 235.64 452.11 240.72 452.09 249.3 445.45 249.83 445.44 255.75 437.54 255.79 437.5 259.25 415.52 259.49 415.7 239.77 420.34 239.96 420.4 232.7 414.63 232.74 414.7 228.21 418 228.19 428.9 230.41 428.83 226.25 434.64 226.16 434.58 220.58 422.29 220.21 422.4 224.02 418.41 221.46 414.78 216.35 420.24 216.37 419.87 210.24 424.04 210.27 446.41 209.73 Z"
          data-mrisynd="dma 616"
          data-state_name="Kansas City, MO-KS"
          id="616"
        />
        <path
          className="white"
          d="M 524.02 168.26 511.25 169.28 510.28 169.39 509.75 162.63 506.43 162.79 505.42 147.66 517.28 148.47 516.71 141.76 522.65 141.25 521.21 153.84 524.02 168.26 Z"
          data-mrisynd="dma 617"
          data-state_name="Milwaukee, WI"
          id="617"
        />
        <path
          className="white"
          d="M 431.97 394.21 430.38 395.15 432.53 405.11 429.3 405.21 431.66 412.41 434.18 412.35 435.88 422.91 428.76 423.61 429.34 418.65 424.59 422.09 428.28 426.81 421.64 429.77 421.42 433.55 423.07 432.47 418.7 436.46 408.67 441.62 404.44 441.94 405.35 438.43 402.15 441.05 400.92 439.01 401.96 441.05 400.02 442.12 400.47 440.23 397.38 439.37 392.46 432.62 398.87 427.45 393.64 421.71 398.78 415.45 395.06 411.59 397.08 409.58 397.64 409.01 405.89 408.26 405.51 398.93 414.59 396.85 425.37 387.98 429.58 393.41 431.97 394.21 Z M 394.95 444.41 393.16 443.25 397.09 439.57 401.43 444.54 396.94 446.79 394.95 444.41 Z M 394.3 449.8 394.32 449.75 401.43 445.92 393.76 451.72 394.3 449.8 Z M 424.68 430.57 429.76 427.4 423.28 432.13 424.68 430.57 Z"
          data-mrisynd="dma 618"
          data-state_name="Houston, TX"
          fillRule="evenodd"
          id="618"
        />
        <path
          className="white"
          d="M 468.14 258.79 468.35 266.7 471.67 266.62 471.56 262.9 481.49 264.24 479.25 268.08 484.15 275.79 481.13 276.13 481.26 281.17 482.93 281.12 483.09 287.44 478.13 287.69 476.57 292.56 467.47 292.74 466.97 295.25 465.36 298.39 455.44 296.01 455.57 303.57 452.26 303.59 446.75 303.64 447.72 296.91 441.23 292.44 441.04 288.97 437.81 289.04 437.5 259.25 437.54 255.79 445.44 255.75 445.45 249.83 452.09 249.3 452.09 254.53 454.3 255.35 458.69 255.24 460.69 258.86 468.14 258.79 Z"
          data-mrisynd="dma 619"
          data-state_name="Springfield, MO"
          id="619"
        />
        <path
          className="white"
          d="M 487.8 421.47 493.66 414.78 492.92 410.3 501.27 406.51 498.3 402.81 498.06 392.95 509.75 392.2 517.76 391.49 518.02 393.41 518.75 403.72 517.31 407.38 510.65 411.39 514.61 413.76 516.77 409.51 519.43 413.02 518.2 414.44 520.56 414.45 517.66 415.02 518.22 417.14 514.43 415.95 517.34 418.25 513.38 418.82 516.32 422.7 521.52 423.39 519.51 427.28 505.88 419.91 508.41 427.15 505.58 429.32 501.66 424.49 494.94 429.9 486.71 426.26 488.35 424.73 490.4 426.87 487.8 421.47 Z"
          data-mrisynd="dma 622"
          data-state_name="New Orleans, LA"
          id="622"
        />
        <path
          className="white"
          d="M 412.54 385.83 412.57 382.93 404.41 387.56 400.18 380.18 393.06 381.81 391.38 378.82 371.07 387.07 367.59 381.06 364.71 381.44 360.76 374.05 368.18 370 366.88 357.32 369.27 357.42 369.61 347.49 384.52 348.44 384.71 339.14 385.78 341.03 389.21 339.26 390.46 343.04 393.29 338.59 393.2 348.89 398.26 349.22 402.13 349.31 402.24 342.98 405.92 340.82 419.09 339.9 421.69 338.84 428.47 342.91 428.23 350.72 422.26 349.41 419.35 349.69 419.39 357.67 413.67 357.76 414.84 367.02 417.22 369.46 417.31 379.28 420.4 383.75 412.54 385.83 Z"
          data-mrisynd="dma 623"
          data-state_name="Dallas-Ft. Worth, TX"
          id="623"
        />
        <path
          className="white"
          d="M 382.13 187.51 382.34 174.05 375.68 173.93 375.83 165.32 379.94 167.73 389.91 165.88 396.92 169.11 397 161.79 402.13 161.22 400.53 158.41 416.83 158.49 416.82 153.75 424.23 153.67 429.98 153.6 430.16 165.04 423.54 165.1 424.48 178.62 421.18 178.64 412.95 178.68 412.96 185.41 393.79 180.94 393.73 186.23 382.13 187.51 Z"
          data-mrisynd="dma 624"
          data-state_name="Sioux City, IA"
          id="624"
        />
        <path
          className="white"
          d="M 357.31 395.83 357.67 385.85 364.71 381.44 367.59 381.06 371.07 387.07 391.38 378.82 393.06 381.81 400.18 380.18 404.41 387.56 412.57 382.93 412.54 385.83 413.94 389.24 411.95 393.2 414.59 396.85 405.51 398.93 405.89 408.26 397.64 409.01 392.32 403.95 389.12 405.85 387.27 400.47 376.8 394.55 357.31 395.83 Z"
          data-mrisynd="dma 625"
          data-state_name="Waco-Temple-Bryan, TX"
          id="625"
        />
        <path
          className="white"
          d="M 388.59 442.33 388.64 437.94 386.22 436.34 392.46 432.62 397.38 439.37 397.09 439.57 393.16 443.25 390.46 442.5 388.59 442.33 Z"
          data-mrisynd="dma 626"
          data-state_name="Victoria, TX"
          id="626"
        />
        <path
          className="white"
          d="M 336.09 347.61 336.48 339.15 343.94 339.49 345.34 325.53 347.52 326.47 350.51 326.78 350.67 322.57 358.38 320.23 361.05 325.46 363.8 325.54 363.95 320.5 375.51 320.8 375.43 324.15 383.71 324.31 383.65 327.69 384.71 339.14 384.52 348.44 369.61 347.49 369.27 357.42 366.88 357.32 360.86 357.1 361.06 348.59 352.78 348.28 352.97 341.47 349.46 340.07 344.77 339.52 344.5 347.98 336.09 347.61 Z"
          data-mrisynd="dma 627"
          data-state_name="Wichita Falls &amp; Lawton, TX-OK"
          id="627"
        />
        <path
          className="white"
          d="M 457.7 381.1 457.99 372.62 460.62 370.87 458.64 363.9 461.05 360.73 460.89 355.84 456.66 355.89 456.59 348.95 463.49 348.93 469.68 352.61 472.37 347.96 480.89 347.76 481.2 355.14 485.92 354.94 485.33 356.69 487.66 356.74 486.2 359.9 487.99 360.28 486.53 362.4 488.7 361.8 489.3 364.63 487.25 364.95 491.24 366.87 489.49 370.42 486.74 370.49 489.37 371.4 485.42 377.23 481.56 381.67 483.41 382.61 480.75 390.16 481.19 393.25 478.67 393.09 479.15 390.1 474.14 389.81 467.39 382.49 467.61 379.07 457.7 381.1 Z"
          data-mrisynd="dma 628"
          data-state_name="Monroe-El Dorado, LA-AR"
          id="628"
        />
        <path
          className="white"
          d="M 539.8 360.38 539.44 360.15 536.03 359.01 533.94 351.91 531.24 352.22 531.44 341.68 536.68 341.45 535.78 331.87 531.68 331.51 531.8 326.4 558.52 324.3 561.65 327.94 568.69 325.25 573.21 318.46 576.2 329 572.62 331.11 573.08 335.48 569.48 339.21 573.32 338.42 573.99 345.92 568.34 346.85 569.06 353.27 553.02 356.66 552.67 353.32 546.16 353.19 545.18 360.88 539.8 360.38 Z"
          data-mrisynd="dma 630"
          data-state_name="Birmingham (Anniston and Tuscaloosa)"
          id="630"
        />
        <path
          className="white"
          d="M 470.24 204.34 470.45 208.5 467.16 208.5 467.32 214.41 461.51 214.61 462.73 228.09 454.47 226.54 454.41 220.01 446.82 220.31 446.41 209.73 457.09 209.19 456.68 198.46 459.99 198.01 469.97 197.58 470.24 204.34 Z"
          data-mrisynd="dma 631"
          data-state_name="Ottumwa-Kirksville, IA-MO"
          id="631"
        />
        <path
          className="white"
          d="M 534.76 271.2 533.78 274.68 527.99 277.26 530.17 284.28 523.08 284.75 523.4 291.56 521.05 293.44 513.72 291.23 506.44 292.11 506.74 287.87 501.09 288.53 501.59 296.06 496.51 296.42 495.15 296.51 499.54 290.15 498.02 286.6 491.53 286.97 490.39 280.97 482.93 281.12 481.26 281.17 481.13 276.13 484.15 275.79 487.82 276.46 488.25 272.16 491.06 271.97 490.88 264.78 496.75 264.48 500.97 259.07 503.67 260.88 504.35 252.77 511.02 252.43 510.7 247.38 517.35 246.86 517.62 251.08 522.58 250.7 523.07 257.42 528.37 258.34 527.1 263.35 534.76 271.2 Z"
          data-mrisynd="dma 632"
          data-state_name="Paducah-Cape Girardeau-Harrisburg, K"
          id="632"
        />
        <path
          className="white"
          d="M 259.9 395.65 275.14 387.83 277.87 370.77 282.77 371.18 283.57 361.13 287.95 363.5 294.24 361.21 324.68 363.91 324.07 372.3 321.52 391.59 303.2 390.35 311.42 394.07 314.78 400.05 312.66 406.32 312.03 415.99 302.88 413.55 296.72 415.72 292.79 425.43 285.44 429.64 265.95 415.41 259.9 395.65 Z"
          data-mrisynd="dma 633"
          data-state_name="Odessa-Midland, TX"
          id="633"
        />
        <path
          className="white"
          d="M 316.18 276.83 347.25 278.3 345.34 325.53 343.94 339.49 336.48 339.15 336.08 329.87 297.09 327.52 295.89 341.82 285.43 339.35 284.15 330.99 282.51 330.83 283.3 320.77 280.48 320.52 281.44 310.17 293.43 306.19 294.68 292.93 284.92 290.43 286.27 274.57 289.17 274.77 316.18 276.83 Z"
          data-mrisynd="dma 634"
          data-state_name="Amarillo, TX"
          id="634"
        />
        <path
          className="white"
          d="M 393.64 421.71 389.14 421.75 386.26 418.72 381.18 421.53 377.16 417.18 374.85 419.13 370 413.54 368.01 415.42 365.2 411.49 353.34 411.2 353.42 408.28 353.53 404.18 350.54 404.07 350.85 395.62 357.31 395.83 376.8 394.55 387.27 400.47 389.12 405.85 392.32 403.95 397.64 409.01 397.08 409.58 395.06 411.59 398.78 415.45 393.64 421.71 Z"
          data-mrisynd="dma 635"
          data-state_name="Austin, TX"
          id="635"
        />
        <path
          className="white"
          d="M 353.26 479.31 357.12 475.37 373.9 475.89 373.83 479.03 383.18 479.5 386.3 491.02 388.27 491.5 383.87 494 379.22 490.13 369.94 489.64 354.67 482.7 353.26 479.31 Z M 387.06 483.78 385.16 480.27 388.12 489.69 387.06 483.78 Z"
          data-mrisynd="dma 636"
          data-state_name="Harlingen-Weslaco-Brownsville-McAlle"
          fillRule="evenodd"
          id="636"
        />
        <path
          className="white"
          d="M 469.97 197.58 459.99 198.01 461.07 184.39 454.4 184.65 454.14 177.92 450.83 178.05 450.07 164.57 456.68 164.36 456.47 158.46 463.08 158.2 462.87 152.66 467.74 152.45 468.91 152.39 474.86 152.11 477.33 156.72 476.21 161.94 477.91 166.68 483.97 170.81 486.47 173.12 480.57 175.13 481.27 188.62 474.6 188.92 473.28 197.44 469.97 197.58 Z"
          data-mrisynd="dma 637"
          data-state_name="Cedar Rapids-Waterloo-Iowa City &amp; Du"
          id="637"
        />
        <path
          className="white"
          d="M 418 228.19 417.95 221.46 418.41 221.46 422.4 224.02 422.29 220.21 434.58 220.58 434.64 226.16 428.83 226.25 428.9 230.41 418 228.19 Z"
          data-mrisynd="dma 638"
          data-state_name="St. Joseph, MO"
          id="638"
        />
        <path
          className="white"
          d="M 533.66 312.95 530.32 313.44 527.76 313.64 527.34 310.2 527.17 306.21 520.86 309.29 519.66 305.87 515.98 306.08 515.74 301.03 518.36 299.07 513.19 295.02 513.72 291.23 521.05 293.44 523.4 291.56 528.3 291.25 528.88 305.23 532.68 306.58 533.66 312.95 Z"
          data-mrisynd="dma 639"
          data-state_name="Jackson, TN"
          id="639"
        />
        <path
          className="white"
          d="M 527.76 313.64 528.09 318.27 522.58 318.67 522.69 321.77 514.53 322.36 515.13 330.78 504.29 331.44 496.29 335.4 488.16 333.27 485.58 333.41 487.19 329.11 484.26 318.13 485.85 316.32 485.26 302.63 496.89 302.15 496.51 296.42 501.59 296.06 501.09 288.53 506.74 287.87 506.44 292.11 513.72 291.23 513.19 295.02 518.36 299.07 515.74 301.03 515.98 306.08 519.66 305.87 520.86 309.29 527.17 306.21 527.34 310.2 527.76 313.64 Z"
          data-mrisynd="dma 640"
          data-state_name="Memphis, TN"
          id="640"
        />
        <path
          className="white"
          d="M 312.03 415.99 312.66 406.32 353.42 408.28 353.34 411.2 365.2 411.49 368.01 415.42 370 413.54 374.85 419.13 377.16 417.18 381.18 421.53 386.26 418.72 389.14 421.75 393.64 421.71 398.87 427.45 392.46 432.62 386.22 436.34 388.64 437.94 388.59 442.33 383.7 445.14 372.79 437.59 368.69 440.83 368.45 451.43 360.45 451.21 350.44 451.41 350.47 448.07 336.53 447.66 327.58 427.13 320.2 421.49 317.99 416.56 312.03 415.99 Z"
          data-mrisynd="dma 641"
          data-state_name="San Antonio, TX"
          id="641"
        />
        <path
          className="white"
          d="M 477.32 396.92 478.6 403.61 483.81 410.97 487.86 411.95 490.39 417.31 485.4 417.02 483.81 413.78 477.58 418.26 477.98 416.45 475.56 416.5 471.7 418.3 474.51 421.34 464.96 421.8 464.69 413 458.34 413.21 459.99 410.89 455.87 405.89 464.19 404.36 464.39 396.52 467.86 394.36 471.96 397.13 477.32 396.92 Z M 474.72 421.43 480.28 421.36 478.38 423.28 474.72 421.43 Z"
          data-mrisynd="dma 642"
          data-state_name="Lafayette, LA"
          fillRule="evenodd"
          id="642"
        />
        <path
          className="white"
          d="M 464.39 396.52 464.19 404.36 455.87 405.89 459.99 410.89 458.34 413.21 464.69 413 464.96 421.8 454.6 418.32 444.46 420.25 442.91 418.01 446.27 413.24 445.71 403.92 448.56 397.53 464.39 396.52 Z"
          data-mrisynd="dma 643"
          data-state_name="Lake Charles, LA"
          id="643"
        />
        <path
          className="white"
          d="M 464.39 396.52 448.56 397.53 448.51 391.44 451.08 387.93 458.36 388.05 461.97 384.64 457.7 381.1 467.61 379.07 467.39 382.49 474.14 389.81 479.15 390.1 478.67 393.09 477.32 396.92 471.96 397.13 467.86 394.36 464.39 396.52 Z"
          data-mrisynd="dma 644"
          data-state_name="Alexandria, LA"
          id="644"
        />
        <path
          className="white"
          d="M 509.94 348.09 499.05 347.04 498.47 349.7 492.63 349.52 493.55 352.73 485.92 354.94 481.2 355.14 480.89 347.76 480.79 344.37 484.14 345.11 485.9 343.35 484.38 341.71 487.37 341.91 485.5 340.22 487.94 339.9 486.18 336.26 489.3 334.93 488.16 333.27 496.29 335.4 504.29 331.44 504.71 336.57 511.39 336.73 511.64 340.38 507.19 340.69 509.94 348.09 Z"
          data-mrisynd="dma 647"
          data-state_name="Greenwood-Greenville, MS"
          id="647"
        />
        <path
          className="white"
          d="M 521.69 238.04 515.09 238.54 514.67 232.66 503.78 230.85 503.51 227.46 492.22 228.27 490.93 223.83 487.55 223.31 490.74 216.64 498.52 216.17 501.73 215.97 501.45 212.16 518.12 211.67 517.62 205.2 520.87 204.92 520.1 197.67 530.45 196.48 530.92 201.75 531.86 213.12 533.02 226.07 525.91 226.61 526.51 232.53 524.12 232.76 521.3 233.01 521.69 238.04 Z"
          data-mrisynd="dma 648"
          data-state_name="Champaign &amp; Springfield-Decatur, IL"
          id="648"
        />
        <path
          className="white"
          d="M 547.29 243.23 547.83 248.31 551.91 251.49 548.75 257.37 550.5 264.94 547.54 266.54 546.12 271.72 534.76 271.2 527.1 263.35 528.37 258.34 523.07 257.42 522.58 250.7 517.62 251.08 517.35 246.86 517.15 244.33 523.79 243.92 532.8 243.77 531.68 246.86 536.21 244 543.27 244.27 547.29 243.23 Z"
          data-mrisynd="dma 649"
          data-state_name="Evansville, IN"
          id="649"
        />
        <path
          className="white"
          d="M 345.34 325.53 347.25 278.3 396.85 279.59 396.77 283.8 391.98 285.65 394.66 287.79 392.44 289.08 392.4 292.45 398.71 295.87 399.6 310.65 401.42 309.28 401.4 312.73 408.57 312.75 406.84 322.84 401.89 322.83 401.92 319.64 396.92 321.08 393.72 318.95 394.37 331.18 383.65 327.69 383.71 324.31 375.43 324.15 375.51 320.8 363.95 320.5 363.8 325.54 361.05 325.46 358.38 320.23 350.67 322.57 350.51 326.78 347.52 326.47 345.34 325.53 Z"
          data-mrisynd="dma 650"
          data-state_name="Oklahoma City, OK"
          id="650"
        />
        <path
          className="white"
          d="M 336.48 339.15 336.09 347.61 335.66 355.99 325.16 355.44 324.68 363.91 294.24 361.21 295.89 341.82 297.09 327.52 336.08 329.87 336.48 339.15 Z"
          data-mrisynd="dma 651"
          data-state_name="Lubbock, TX"
          id="651"
        />
        <path
          className="white"
          d="M 421.18 178.64 422.03 192.28 426.91 192.24 427 198.94 423.74 198.97 424.04 210.27 419.87 210.24 420.24 216.37 414.78 216.35 418.41 221.46 417.95 221.46 408.13 221.48 408.14 216.42 401.51 216.4 401.59 201.24 395.18 201.16 395.29 193.26 385.32 195.48 382.06 191.69 382.13 187.51 393.73 186.23 393.79 180.94 412.96 185.41 412.95 178.68 421.18 178.64 Z"
          data-mrisynd="dma 652"
          data-state_name="Omaha, NE"
          id="652"
        />
        <path
          className="white"
          d="M 567.31 397.97 566.36 387.65 569.66 387.31 589.05 385.04 592.09 390.54 591.07 392.45 596.27 396.05 596.82 401.61 600.67 403.46 602.42 404.73 586.33 411.37 584.74 408.05 586.04 410.95 586.4 407.81 579.68 403.07 584.72 403.88 578.79 402.13 580.65 399.97 576.62 400.32 578.89 403.19 567.41 399.43 567.39 399.06 572.1 398.76 570.43 396.72 567.31 397.97 Z"
          data-mrisynd="dma 656"
          data-state_name="Panama City, FL"
          id="656"
        />
        <path
          className="white"
          d="M 384.71 339.14 383.65 327.69 394.37 331.18 393.72 318.95 396.92 321.08 401.92 319.64 401.89 322.83 406.84 322.84 410.14 326.22 423.07 324.46 424.99 324.44 425.03 327.8 421.71 332.91 421.69 338.84 419.09 339.9 405.92 340.82 402.24 342.98 402.13 349.31 398.26 349.22 393.2 348.89 393.29 338.59 390.46 343.04 389.21 339.26 385.78 341.03 384.71 339.14 Z"
          data-mrisynd="dma 657"
          data-state_name="Sherman-Ada, TX-OK"
          id="657"
        />
        <path
          className="white"
          d="M 522.65 141.25 516.71 141.76 517.28 148.47 505.42 147.66 502.09 147.69 502.68 141.08 496.76 141.51 496.42 136.44 501.55 136.12 500.48 121.03 508.26 118.75 507.39 113.78 510.76 113.55 510.27 106.93 520.05 106.1 520.68 100.98 524.02 100.69 526.16 108.88 517.18 128.74 523.08 122.64 525.83 122.79 527.21 116.15 530.56 113.59 522.65 141.25 Z"
          data-mrisynd="dma 658"
          data-state_name="Green Bay-Appleton, WI"
          id="658"
        />
        <path
          className="white"
          d="M 523.4 291.56 523.08 284.75 530.17 284.28 527.99 277.26 533.78 274.68 534.76 271.2 546.12 271.72 554.82 276.56 558.6 273.13 561.46 276.92 568.98 271.9 572.35 271.77 575.04 272.76 576.54 277.14 579.85 277.18 580.85 278.59 575.47 279.7 574.55 294.12 571.85 298.69 565.33 299.98 566.72 310.13 559.66 310.82 555.44 304.01 551.29 307.35 551.59 311.6 533.66 312.95 532.68 306.58 528.88 305.23 528.3 291.25 523.4 291.56 Z"
          data-mrisynd="dma 659"
          data-state_name="Nashville, TN"
          id="659"
        />
        <path
          className="white"
          d="M 357.67 385.85 357.31 395.83 350.85 395.62 350.54 404.07 353.53 404.18 353.42 408.28 312.66 406.32 314.78 400.05 311.42 394.07 303.2 390.35 321.52 391.59 324.07 372.3 339.47 373.17 339.05 382.8 357.67 385.85 Z"
          data-mrisynd="dma 661"
          data-state_name="San Angelo, TX"
          id="661"
        />
        <path
          className="white"
          d="M 366.88 357.32 368.18 370 360.76 374.05 364.71 381.44 357.67 385.85 339.05 382.8 339.47 373.17 324.07 372.3 324.68 363.91 325.16 355.44 335.66 355.99 336.09 347.61 344.5 347.98 344.77 339.52 349.46 340.07 352.97 341.47 352.78 348.28 361.06 348.59 360.86 357.1 366.88 357.32 Z"
          data-mrisynd="dma 662"
          data-state_name="Abilene-Sweetwater, TX"
          id="662"
        />
        <path
          className="white"
          d="M 494.05 170.25 483.99 170.81 483.97 170.81 477.91 166.68 476.21 161.94 482.89 158.04 482.4 150.68 487.41 150.38 486.59 137 492.23 136.63 490.75 140.22 494.57 148.24 497.18 148.05 496.76 141.51 502.68 141.08 502.09 147.69 505.42 147.66 506.43 162.79 509.75 162.63 510.28 169.39 506.24 169.6 494.05 170.25 Z"
          data-mrisynd="dma 669"
          data-state_name="Madison, WI"
          id="669"
        />
        <path
          className="white"
          d="M 432.54 327.68 425.03 327.8 424.99 324.44 423.07 324.46 426.79 311.98 422.5 309.33 421.84 305.93 432.01 305.8 429.51 289.17 437.81 289.04 441.04 288.97 441.23 292.44 447.72 296.91 446.75 303.64 452.26 303.59 450.76 313.64 444.13 315.32 444.26 322.84 432.57 323.4 432.54 327.68 Z"
          data-mrisynd="dma 670"
          data-state_name="Ft. Smith-Fayettville-Springdale-Rod"
          id="670"
        />
        <path
          className="white"
          d="M 396.85 279.59 400.26 279.63 400.31 273.74 408.87 272.14 415.55 272.17 415.57 279.62 423.42 279.56 423.61 285.93 429.46 285.91 429.51 289.17 432.01 305.8 421.84 305.93 422.5 309.33 426.79 311.98 423.07 324.46 410.14 326.22 406.84 322.84 408.57 312.75 401.4 312.73 401.42 309.28 399.6 310.65 398.71 295.87 392.4 292.45 392.44 289.08 394.66 287.79 391.98 285.65 396.77 283.8 396.85 279.59 Z"
          data-mrisynd="dma 671"
          data-state_name="Tulsa, OK"
          id="671"
        />
        <path
          className="white"
          d="M 527.76 313.64 530.32 313.44 532.07 315.29 531.8 326.4 531.68 331.51 535.78 331.87 536.68 341.45 531.44 341.68 531.24 352.22 515.63 354.54 515.19 347.73 509.94 348.09 507.19 340.69 511.64 340.38 511.39 336.73 504.71 336.57 504.29 331.44 515.13 330.78 514.53 322.36 522.69 321.77 522.58 318.67 528.09 318.27 527.76 313.64 Z"
          data-mrisynd="dma 673"
          data-state_name="Columbus-Tupelo-West Point, MS"
          id="673"
        />
        <path
          className="white"
          d="M 490.74 216.64 492.94 215.34 489.26 215.47 488.85 206.98 495.4 204.94 494.89 196.49 496.46 194.74 502.34 196.01 506.47 192.59 508.67 199.89 510.35 199.73 510.1 196.29 519.85 195.36 520.1 197.67 520.87 204.92 517.62 205.2 518.12 211.67 501.45 212.16 501.73 215.97 498.52 216.17 490.74 216.64 Z"
          data-mrisynd="dma 675"
          data-state_name="Peoria-Bloomington, IL"
          id="675"
        />
        <path
          className="white"
          d="M 489.3 88.39 491.58 93.23 501.81 95.82 502.14 100.34 489.35 97.32 489.74 103.42 483.41 103.81 479.71 104.02 480.05 110.6 468.44 111.21 467.83 101.26 457.9 101.68 457.72 96.7 447.56 97.02 447.18 85.39 437.67 85.58 437.56 80.32 433.28 77.11 429.16 78 428.62 60.23 428.5 53.89 436.11 55.11 436.9 57.24 447.59 54.77 451.72 56.29 450.77 57.85 454.11 58.65 455.37 62.3 459.34 59.49 465.94 65.22 474.59 60.93 476.49 63.79 492.93 64.4 476.66 73.04 459.12 91 464.1 91.14 476.21 85.37 477.75 86.73 475.52 92.6 477.82 90.19 482.26 92.74 489.3 88.39 Z"
          data-mrisynd="dma 676"
          data-state_name="Duluth-Superior, MN-WI"
          id="676"
        />
        <path
          className="white"
          d="M 379.83 229.59 379.76 234.65 388.04 234.79 387.96 238.16 394.01 238.23 394.39 250.06 403 250.12 402.92 256.89 408.9 256.93 408.9 259.48 408.87 272.14 400.31 273.74 400.26 279.63 396.85 279.59 347.25 278.3 316.18 276.83 316.98 264.25 317 263.96 317.71 252.16 318.12 245.45 320.17 211.92 330.77 212.53 330.38 219.26 355.22 220.45 354.86 228.86 379.83 229.59 Z"
          data-mrisynd="dma 678"
          data-state_name="Wichita-Hutchinson Plus, KS"
          id="678"
        />
        <path
          className="white"
          d="M 446.41 209.73 424.04 210.27 423.74 198.97 427 198.94 426.91 192.24 422.03 192.28 421.18 178.64 424.48 178.62 423.54 165.1 430.16 165.04 429.98 153.6 432.68 153.56 436.55 153.5 436.78 164.92 450.07 164.57 450.83 178.05 454.14 177.92 454.4 184.65 461.07 184.39 459.99 198.01 456.68 198.46 457.09 209.19 446.41 209.73 Z"
          data-mrisynd="dma 679"
          data-state_name="Des Moines-Ames, IA"
          id="679"
        />
        <path
          className="white"
          d="M 494.05 170.25 494.52 176.22 497.79 175.95 499.4 187.74 506.04 187.28 506.47 192.59 502.34 196.01 496.46 194.74 494.89 196.49 495.4 204.94 488.85 206.98 478.12 207.38 479.11 206.18 475.66 204.61 470.24 204.34 469.97 197.58 473.28 197.44 474.6 188.92 481.27 188.62 480.57 175.13 486.47 173.12 483.97 170.81 483.99 170.81 494.05 170.25 Z"
          data-mrisynd="dma 682"
          data-state_name="Davenport-Rock Island-Moline, IA-IL"
          id="682"
        />
        <path
          className="white"
          d="M 534.36 402.27 532.94 390.59 526.22 391.11 525.47 382.77 531.88 382.23 531.23 377.23 537.35 376.7 535.66 374.5 537.12 371.09 543.7 370.51 544.75 373.59 556.32 372.46 557.51 377.83 561.02 379.96 561.25 388.04 566.36 387.65 567.31 397.97 554.5 401.4 559.42 399.03 557.29 396.54 555.83 399.4 553.97 396.79 553.11 401.47 549.34 402.43 551.75 399.92 550.01 398.75 548.41 403.31 540.7 404.9 545.15 403.38 540.3 394.27 538.87 402.82 534.36 402.27 Z M 567.39 399.06 567.41 399.43 565.43 399.27 567.39 399.06 Z M 550.03 402.69 552.38 401.88 548.48 403.29 550.03 402.69 Z"
          data-mrisynd="dma 686"
          data-state_name="Mobile-Pensacola (Ft. Walton Beach),"
          fillRule="evenodd"
          id="686"
        />
        <path
          className="white"
          d="M 367.92 106.18 358.36 105.82 358.09 112.49 347.7 112.94 349.57 114.45 334.32 113.66 327.16 113.23 327.73 104.19 299.05 103.26 294.37 97.94 289.44 97.48 289.8 90.86 292.09 91.07 292.32 88.58 298.7 80.9 296.81 71.39 287.86 65.54 286.19 65.39 285.89 68.39 284.48 76.9 278.15 77.97 275.55 76 273.15 72.4 274.69 62.69 272.83 60.78 273.37 58.78 280.38 60.57 281.98 50.15 279.19 49.86 278.91 41.51 363.1 47.54 363.07 59.5 358.51 59.32 358.22 65.99 358.55 69.31 365.27 69.58 365.33 79.51 362.51 79.41 362.43 92.73 367.92 92.93 367.92 106.18 Z"
          data-mrisynd="dma 687"
          data-state_name="Minot-Bismarck-Dickinson (Williston)"
          id="687"
        />
        <path
          className="white"
          d="M 566.72 310.13 570.79 309.76 572.86 317.23 573.21 318.46 568.69 325.25 561.65 327.94 558.52 324.3 531.8 326.4 532.07 315.29 530.32 313.44 533.66 312.95 551.59 311.6 551.29 307.35 555.44 304.01 559.66 310.82 566.72 310.13 Z"
          data-mrisynd="dma 691"
          data-state_name="Huntsville-Decatur (Florence), AL"
          id="691"
        />
        <path
          className="white"
          d="M 444.46 420.25 435.88 422.91 434.18 412.35 431.66 412.41 429.3 405.21 432.53 405.11 430.38 395.15 431.97 394.21 447.73 391.63 448.51 391.44 448.56 397.53 445.71 403.92 446.27 413.24 442.91 418.01 444.46 420.25 Z"
          data-mrisynd="dma 692"
          data-state_name="Beaumont-Port Arthur, TX"
          id="692"
        />
        <path
          className="white"
          d="M 456.59 348.95 448.48 347.84 448.65 337.9 442.81 337.13 440.89 330.57 435.85 330.57 436.07 333.7 432.49 333.82 432.54 327.68 432.57 323.4 444.26 322.84 444.13 315.32 450.76 313.64 452.26 303.59 455.57 303.57 455.44 296.01 465.36 298.39 466.97 295.25 468.48 299.11 472.54 300.16 485.15 299.22 485.26 302.63 485.85 316.32 484.26 318.13 487.19 329.11 485.58 333.41 488.16 333.27 489.3 334.93 486.18 336.26 487.94 339.9 485.5 340.22 487.37 341.91 484.38 341.71 485.9 343.35 484.14 345.11 480.79 344.37 480.89 347.76 472.37 347.96 469.68 352.61 463.49 348.93 456.59 348.95 Z"
          data-mrisynd="dma 693"
          data-state_name="Little Rock-Pine Bluff, AR"
          id="693"
        />
        <path
          className="white"
          d="M 575.56 374.61 569.09 375.31 569.66 387.31 566.36 387.65 561.25 388.04 561.02 379.96 557.51 377.83 556.32 372.46 544.75 373.59 543.7 370.51 537.12 371.09 539 365.19 536.99 362.7 539.8 360.38 545.18 360.88 546.16 353.19 552.67 353.32 553.02 356.66 569.06 353.27 568.34 346.85 573.99 345.92 574.94 345.8 574.41 356.05 578.71 357.22 579.94 364.03 576.42 370.96 575.56 374.61 Z"
          data-mrisynd="dma 698"
          data-state_name="Montgomery-Selma, AL"
          id="698"
        />
        <path
          className="white"
          d="M 467.74 152.45 467.44 145.77 462.6 145.98 462.4 140.96 465.38 139.17 464.43 136.71 458.8 132.74 461.28 132.66 461.18 129.88 467.8 129.61 468.44 111.21 480.05 110.6 480.33 115.6 477 115.75 477.38 122.44 485.65 121.92 486.59 137 487.41 150.38 482.4 150.68 482.89 158.04 476.21 161.94 477.33 156.72 474.86 152.11 468.91 152.39 467.74 152.45 Z"
          data-mrisynd="dma 702"
          data-state_name="La Crosse-Eau Claire, WI"
          id="702"
        />
        <path
          className="white"
          d="M 502.14 100.34 506.36 101.62 506.9 107.18 510.27 106.93 510.76 113.55 507.39 113.78 508.26 118.75 500.48 121.03 501.55 136.12 496.42 136.44 496.76 141.51 497.18 148.05 494.57 148.24 490.75 140.22 492.23 136.63 486.59 137 485.65 121.92 477.38 122.44 477 115.75 480.33 115.6 480.05 110.6 479.71 104.02 483.41 103.81 489.74 103.42 489.35 97.32 502.14 100.34 Z"
          data-mrisynd="dma 705"
          data-state_name="Wausau-Rhinelander, WI"
          id="705"
        />
        <path
          className="white"
          d="M 414.59 396.85 411.95 393.2 413.94 389.24 412.54 385.83 420.4 383.75 417.31 379.28 417.22 369.46 414.84 367.02 413.67 357.76 419.39 357.67 419.35 349.69 422.26 349.41 422.31 356.27 425.49 355.54 429.66 360 429.3 368 432.71 368.49 431.07 376.62 434.4 382.68 445.73 385.2 447.73 391.63 431.97 394.21 429.58 393.41 425.37 387.98 414.59 396.85 Z"
          data-mrisynd="dma 709"
          data-state_name="Tyler-Longview (Lufkin &amp; Nacogdoches"
          id="709"
        />
        <path
          className="white"
          d="M 516.54 368.18 523.16 367.68 523.78 375.32 530.79 373.47 531.23 377.23 531.88 382.23 525.47 382.77 526.22 391.11 518.02 393.41 517.76 391.49 509.75 392.2 506.33 389.07 505.92 384.88 513.29 383.64 510.11 377.28 517.21 376.25 516.54 368.18 Z"
          data-mrisynd="dma 710"
          data-state_name="Hattiesburg-Laurel, MS"
          id="710"
        />
        <path
          className="white"
          d="M 539.8 360.38 536.99 362.7 539 365.19 537.12 371.09 535.66 374.5 537.35 376.7 531.23 377.23 530.79 373.47 523.78 375.32 523.16 367.68 516.54 368.18 515.63 354.54 531.24 352.22 533.94 351.91 536.03 359.01 539.44 360.15 539.8 360.38 Z"
          data-mrisynd="dma 711"
          data-state_name="Meridian, MS"
          id="711"
        />
        <path
          className="white"
          d="M 477.58 418.26 483.81 413.78 485.4 417.02 490.39 417.31 487.86 411.95 483.81 410.97 478.6 403.61 477.32 396.92 478.67 393.09 481.19 393.25 480.75 390.16 485.74 386.49 497.66 386.24 498.06 392.95 498.3 402.81 501.27 406.51 492.92 410.3 493.66 414.78 487.8 421.47 482.88 422.22 481.52 418.1 477.58 418.26 Z"
          data-mrisynd="dma 716"
          data-state_name="Baton Rouge, LA"
          id="716"
        />
        <path
          className="white"
          d="M 488.85 206.98 489.26 215.47 492.94 215.34 490.74 216.64 487.55 223.31 490.93 223.83 492.22 228.27 483.01 231.14 478.87 227.49 475.24 230.54 475.68 233.08 462.78 233.08 462.73 228.09 461.51 214.61 467.32 214.41 467.16 208.5 470.45 208.5 470.24 204.34 475.66 204.61 479.11 206.18 478.12 207.38 488.85 206.98 Z"
          data-mrisynd="dma 717"
          data-state_name="Quincy-Hannibal-Keokuk, IL-MO-IA"
          id="717"
        />
        <path
          className="white"
          d="M 485.92 354.94 493.55 352.73 492.63 349.52 498.47 349.7 499.05 347.04 509.94 348.09 515.19 347.73 515.63 354.54 516.54 368.18 517.21 376.25 510.11 377.28 513.29 383.64 505.92 384.88 506.33 389.07 509.75 392.2 498.06 392.95 497.66 386.24 485.74 386.49 480.75 390.16 483.41 382.61 481.56 381.67 485.42 377.23 489.37 371.4 486.74 370.49 489.49 370.42 491.24 366.87 487.25 364.95 489.3 364.63 488.7 361.8 486.53 362.4 487.99 360.28 486.2 359.9 487.66 356.74 485.33 356.69 485.92 354.94 Z"
          data-mrisynd="dma 718"
          data-state_name="Jackson, MS"
          id="718"
        />
        <path
          className="white"
          d="M 375.83 165.32 375.68 173.93 382.34 174.05 382.13 187.51 382.06 191.69 385.32 195.48 395.29 193.26 395.18 201.16 401.59 201.24 401.51 216.4 408.14 216.42 408.13 221.48 388.23 221.31 388.15 228.05 379.83 229.59 354.86 228.86 355.22 220.45 330.38 219.26 330.77 212.53 320.17 211.92 320.98 199.26 329.24 199.78 332.53 199.95 332.23 205.88 347.08 206.57 347.63 179.75 349.06 179.81 349.4 162.17 373.24 163.01 375.83 165.32 Z"
          data-mrisynd="dma 722"
          data-state_name="Lincoln &amp; Hastings-Kearny, NE"
          id="722"
        />
        <path
          className="white"
          d="M 428.5 53.89 428.62 60.23 418.5 60.39 418.46 57.06 413.41 57.13 413.59 67 418.32 66.97 418.8 69.78 419.73 103.56 404.72 103.58 400.72 106.89 367.92 106.18 367.92 92.93 362.43 92.73 362.51 79.41 365.33 79.51 365.27 69.58 358.55 69.31 358.22 65.99 358.51 59.32 363.07 59.5 363.1 47.54 419.13 48.34 419.08 41.03 423.38 42.19 425.12 52.46 428.5 53.89 Z"
          data-mrisynd="dma 724"
          data-state_name="Fargo-Valley City, ND"
          id="724"
        />
        <path
          className="white"
          d="M 334.32 113.66 349.57 114.45 347.7 112.94 358.09 112.49 358.36 105.82 367.92 106.18 400.72 106.89 396.71 113.18 402.13 119.08 402.1 131.97 407.01 131.99 407.2 140.35 415.7 140.34 416.82 153.75 416.83 158.49 400.53 158.41 402.13 161.22 397 161.79 396.92 169.11 389.91 165.88 379.94 167.73 375.83 165.32 373.24 163.01 349.4 162.17 334.97 161.47 335.82 146.09 348.06 148.22 348.17 145.72 348.07 139.51 337.06 138.97 338.32 123.11 336.56 123.03 333.37 122.83 334.32 113.66 Z"
          data-mrisynd="dma 725"
          data-state_name="Sioux Falls (Mitchell), SD"
          id="725"
        />
        <path
          className="white"
          d="M 496.51 296.42 496.89 302.15 485.26 302.63 485.15 299.22 472.54 300.16 468.48 299.11 466.97 295.25 467.47 292.74 476.57 292.56 478.13 287.69 483.09 287.44 482.93 281.12 490.39 280.97 491.53 286.97 498.02 286.6 499.54 290.15 495.15 296.51 496.51 296.42 Z"
          data-mrisynd="dma 734"
          data-state_name="Jonesboro, AR"
          id="734"
        />
        <path
          className="white"
          d="M 568.98 271.9 561.46 276.92 558.6 273.13 554.82 276.56 546.12 271.72 547.54 266.54 550.5 264.94 558.95 264.22 564.84 262.93 564.91 267.6 568.98 271.9 Z"
          data-mrisynd="dma 736"
          data-state_name="Bowling Green, KY"
          id="736"
        />
        <path
          className="white"
          d="M 432.68 153.56 429.98 153.6 424.23 153.67 424.02 141.97 420.71 142 420.58 138.66 423.89 138.6 423.86 134.44 431.11 138.97 439.04 139.17 439.22 146.72 432.57 146.85 432.68 153.56 Z"
          data-mrisynd="dma 737"
          data-state_name="Mankato, MN"
          id="737"
        />
        <path
          className="white"
          d="M 347.63 179.75 347.08 206.57 332.23 205.88 332.53 199.95 331.09 185.55 339.13 186.03 339.42 179.32 347.63 179.75 Z"
          data-mrisynd="dma 740"
          data-state_name="North Platte, NE"
          id="740"
        />
        <path
          className="white"
          d="M 518.75 403.72 518.02 393.41 526.22 391.11 532.94 390.59 534.36 402.27 518.75 403.72 Z"
          data-mrisynd="dma 746"
          data-state_name="Biloxi-Gulfport, MS"
          id="746"
        />
        <path
          className="white"
          d="M 336.53 447.66 350.47 448.07 350.44 451.41 360.45 451.21 360.09 466.28 357.39 466.16 357.12 475.37 353.26 479.31 348.75 470.56 348.01 460.14 336.53 447.66 Z"
          data-mrisynd="dma 749"
          data-state_name="Laredo, TX"
          id="749"
        />
        <path
          className="white"
          d="M 320.17 211.92 318.12 245.45 288.08 245.04 289.11 233.33 270.24 231.58 269.44 239.91 259.92 239.03 261.1 240.96 258.78 243.84 266.32 256.07 264.85 261.16 269.56 260.99 268.84 273.01 233.57 269.06 235.06 256.76 213.53 254.14 211.23 256.71 212.31 249.09 230.29 253.23 232 250.72 227.02 242.24 236.35 243.99 237.19 236.94 224.2 235.3 224.6 232.21 233.15 228.46 240.41 225.52 239.85 223.64 216.12 220.55 220.47 189.2 236.67 191.31 238.1 178.67 244.06 179.45 245.29 167.83 245.69 164.51 273.33 167.65 272.27 170 275.6 170.62 277.45 164.67 283 165.14 284.51 148 296.23 148.98 295.43 158.65 294.8 166.14 286.33 165.43 284.67 183.85 275.79 182.94 274.56 195.63 292.16 197.17 293.3 183.74 303.03 184.51 302.66 189.55 313.13 190.31 313.43 186.02 313.32 179.34 303.6 178.65 303.07 170.46 303.09 159.28 334.97 161.47 349.4 162.17 349.06 179.81 347.63 179.75 339.42 179.32 339.13 186.03 331.09 185.55 332.53 199.95 329.24 199.78 320.98 199.26 320.17 211.92 Z M 271.95 117.82 284.64 118.96 282.01 147.78 253.86 144.9 254.88 131.94 255.1 127.55 252.75 124.04 271.28 126.06 271.95 117.82 Z M 316.98 264.25 306.34 263.53 307.27 251.49 317.71 252.16 317 263.96 316.98 264.25 Z"
          data-mrisynd="dma 751"
          data-state_name="Denver, CO"
          fillRule="evenodd"
          id="751"
        />
        <path
          className="white"
          d="M 286.27 274.57 268.84 273.01 269.56 260.99 264.85 261.16 266.32 256.07 258.78 243.84 261.1 240.96 259.92 239.03 269.44 239.91 270.24 231.58 289.11 233.33 288.08 245.04 318.12 245.45 317.71 252.16 307.27 251.49 306.34 263.53 316.98 264.25 316.18 276.83 289.17 274.77 286.27 274.57 Z"
          data-mrisynd="dma 752"
          data-state_name="Colorado Springs-Pueblo, CO"
          id="752"
        />
        <path
          className="white"
          d="M 197.78 353.59 175.53 348.86 129.57 341.07 132.62 324.52 118.27 320.1 116.65 328.32 111.4 327.38 110.4 321.73 112.53 319.57 116 310.13 123.34 305.37 120.1 300.88 118.34 289.81 119.84 279.84 120.62 268.79 126.55 268.9 129.46 271.83 131.72 268.91 134.6 253.57 170.79 260.03 195.5 263.98 191.7 289.55 194.37 289.95 191.83 309.53 198.3 310.32 204.26 306.83 197.78 353.59 Z"
          data-mrisynd="dma 753"
          data-state_name="Phoenix (Prescott), AZ"
          id="753"
        />
        <path
          className="white"
          d="M 167.85 88.76 177.69 83.92 178.34 80.43 181.6 81.02 183.34 71.34 180.29 69.41 181.43 62.37 179.3 61.99 180.77 54.09 184.91 54.92 184.59 62.96 187.99 63.61 186.84 70.12 190.24 70.67 189.79 73.23 192.45 74.52 191.73 78.95 199.17 77.36 198.53 91.55 203.78 85.52 207.55 86.03 211.23 86.63 209.29 98.02 205.32 102.05 203.02 115.03 202.52 118.7 198.82 112.61 197.04 116.54 186.07 114.12 184.3 116.17 179.1 114.52 177.67 116.71 175.36 108.22 171.34 105.67 172.06 102 167.85 88.76 Z"
          data-mrisynd="dma 754"
          data-state_name="Butte-Bozeman, MT"
          id="754"
        />
        <path
          className="white"
          d="M 278.91 41.51 279.19 49.86 281.98 50.15 280.38 60.57 273.37 58.78 272.83 60.78 266.09 65.42 256.12 64.69 252.95 68.08 251.67 65.36 247.41 64.91 246.72 70.01 241.33 70.14 241.16 80.18 216.85 78.07 210.02 69.06 201.95 71.13 200.22 70.84 200.92 66.78 197.8 65.01 198.81 58.92 189.15 55.46 188.18 48.57 189.62 48.4 188.73 45.44 185.76 43.92 184.07 36.32 180.71 34.41 181.34 30.57 178.3 29.72 178.07 26.45 278.91 41.51 Z"
          data-mrisynd="dma 755"
          data-state_name="Great Falls, MT"
          id="755"
        />
        <path
          className="white"
          d="M 201.95 71.13 210.02 69.06 216.85 78.07 241.16 80.18 241.33 70.14 246.72 70.01 247.41 64.91 251.67 65.36 252.95 68.08 256.12 64.69 266.09 65.42 272.83 60.78 274.69 62.69 273.15 72.4 275.55 76 274.91 82.09 281.04 83.27 282.76 88.48 292.32 88.58 292.09 91.07 289.8 90.86 289.44 97.48 284.64 118.96 271.95 117.82 246.43 114.71 247.53 119.16 252.75 124.04 255.1 127.55 254.88 131.94 235.68 129.48 227.34 135.22 221.52 131.56 217.77 134.14 214.7 129.65 212.91 118.85 203.02 115.03 205.32 102.05 209.29 98.02 211.23 86.63 207.55 86.03 208.22 81.96 205.87 81 204.02 75 201.95 71.13 Z"
          data-mrisynd="dma 756"
          data-state_name="Billings, MT"
          id="756"
        />
        <path
          className="white"
          d="M 155.98 96.21 153.66 102.71 145.45 106.2 144.66 110.88 147.57 114.93 147.47 119.24 150.62 122.46 152.83 134.83 143.07 132.9 139.09 155.81 111.55 149.85 95.19 146.12 104.82 103.57 109.15 100.89 118.6 105.88 119.3 102.46 127.71 92.58 129.77 89.31 134.34 90.31 134.2 93.42 139.03 92.27 155.98 96.21 Z"
          data-mrisynd="dma 757"
          data-state_name="Boise, ID"
          id="757"
        />
        <path
          className="white"
          d="M 167.85 88.76 172.06 102 171.34 105.67 175.36 108.22 177.67 116.71 179.1 114.52 184.3 116.17 186.07 114.12 197.04 116.54 198.82 112.61 202.52 118.7 203.02 115.03 212.91 118.85 214.7 129.65 213.18 140.02 205.24 143.31 199.05 140.75 196.16 156.4 189.04 153.33 188.88 156.46 184.43 155.98 183.89 159.02 178.1 156.69 177.9 153.15 173.55 155.81 168.72 154.96 169.59 150.01 167.26 149.55 168.07 139.45 171.31 140.06 171.92 136.76 163.58 133.59 163.46 129.3 156.5 122.02 147.47 119.24 147.57 114.93 144.66 110.88 145.45 106.2 153.66 102.71 155.98 96.21 157.7 94.57 155.73 90.29 159.04 89.75 161.75 92.2 163.28 90.81 167.85 88.76 Z"
          data-mrisynd="dma 758"
          data-state_name="Idaho Falls-Pocatello, ID"
          id="758"
        />
        <path
          className="white"
          d="M 303.6 178.65 303.03 184.51 293.3 183.74 292.16 197.17 274.56 195.63 275.79 182.94 284.67 183.85 286.33 165.43 294.8 166.14 295.43 158.65 303.09 159.28 303.07 170.46 303.6 178.65 Z"
          data-mrisynd="dma 759"
          data-state_name="Cheyenne-Scottsbluff, WY-NE"
          id="759"
        />
        <path
          className="white"
          d="M 168.72 154.96 167.58 161.24 139.09 155.81 143.07 132.9 152.83 134.83 150.62 122.46 147.47 119.24 156.5 122.02 163.46 129.3 163.58 133.59 171.92 136.76 171.31 140.06 168.07 139.45 167.26 149.55 169.59 150.01 168.72 154.96 Z"
          data-mrisynd="dma 760"
          data-state_name="Twin Falls, ID"
          id="760"
        />
        <path
          className="white"
          d="M 159.04 89.75 159.83 85.68 162.6 84.05 161.73 78.78 166.28 69.83 160.66 67.79 155.62 55.84 150.62 51.56 152.52 50.84 151.15 49.21 152.16 46.57 149.11 40.42 150.05 35.98 153.93 35.86 155.53 43.11 162.49 42.41 163.17 38.5 165.36 38.93 166.47 30.76 170.31 29.72 169.77 24.79 178.07 26.45 178.3 29.72 181.34 30.57 180.71 34.41 184.07 36.32 185.76 43.92 188.73 45.44 189.62 48.4 188.18 48.57 184.91 54.92 180.77 54.09 179.3 61.99 181.43 62.37 180.29 69.41 183.34 71.34 181.6 81.02 178.34 80.43 177.69 83.92 167.85 88.76 163.28 90.81 161.75 92.2 159.04 89.75 Z"
          data-mrisynd="dma 762"
          data-state_name="Missoula, MT"
          id="762"
        />
        <path
          className="white"
          d="M 334.97 161.47 303.09 159.28 295.43 158.65 296.23 148.98 284.51 148 282.01 147.78 284.64 118.96 289.44 97.48 294.37 97.94 299.05 103.26 327.73 104.19 327.16 113.23 334.32 113.66 333.37 122.83 336.56 123.03 338.32 123.11 337.06 138.97 348.07 139.51 348.17 145.72 348.06 148.22 335.82 146.09 334.97 161.47 Z M 271.95 117.82 271.28 126.06 252.75 124.04 247.53 119.16 246.43 114.71 271.95 117.82 Z M 303.03 184.51 303.6 178.65 313.32 179.34 313.43 186.02 313.13 190.31 302.66 189.55 303.03 184.51 Z"
          data-mrisynd="dma 764"
          data-state_name="Rapid City, SD"
          fillRule="evenodd"
          id="764"
        />
        <path
          className="white"
          d="M 224.41 369.5 226.65 350.43 233.23 351.22 242.57 346.96 239.77 367.04 277.87 370.77 275.14 387.83 259.9 395.65 241.43 377.6 238.64 371.79 224.41 369.5 Z"
          data-mrisynd="dma 765"
          data-state_name="El Paso (Las Cruces), TX-NM"
          id="765"
        />
        <path
          className="white"
          d="M 207.55 86.03 203.78 85.52 198.53 91.55 199.17 77.36 191.73 78.95 192.45 74.52 189.79 73.23 190.24 70.67 186.84 70.12 187.99 63.61 184.59 62.96 184.91 54.92 188.18 48.57 189.15 55.46 198.81 58.92 197.8 65.01 200.92 66.78 200.22 70.84 201.95 71.13 204.02 75 205.87 81 208.22 81.96 207.55 86.03 Z"
          data-mrisynd="dma 766"
          data-state_name="Helena, MT"
          id="766"
        />
        <path
          className="white"
          d="M 213.18 140.02 214.7 129.65 217.77 134.14 221.52 131.56 227.34 135.22 235.68 129.48 254.88 131.94 253.86 144.9 282.01 147.78 284.51 148 283 165.14 277.45 164.67 275.6 170.62 272.27 170 273.33 167.65 245.69 164.51 245.29 167.83 223.9 165.01 224.64 156.72 218.82 149.67 217.27 140.66 213.18 140.02 Z"
          data-mrisynd="dma 767"
          data-state_name="Casper-Riverton, WY"
          id="767"
        />
        <path
          className="white"
          d="M 134.6 253.57 140.75 221.66 126.85 218.91 115.56 206.99 105.52 204.82 113.38 170.08 107.31 168.73 111.55 149.85 139.09 155.81 167.58 161.24 168.72 154.96 173.55 155.81 177.9 153.15 178.1 156.69 183.89 159.02 184.43 155.98 188.88 156.46 189.04 153.33 196.16 156.4 199.05 140.75 205.24 143.31 213.18 140.02 217.27 140.66 218.82 149.67 224.64 156.72 223.9 165.01 245.29 167.83 244.06 179.45 238.1 178.67 236.67 191.31 220.47 189.2 216.12 220.55 212.31 249.09 211.23 256.71 209.92 266.01 195.5 263.98 170.79 260.03 134.6 253.57 Z"
          data-mrisynd="dma 770"
          data-state_name="Salt Lake City, UT"
          id="770"
        />
        <path
          className="white"
          d="M 89.68 315.01 96.05 316.32 112.53 319.57 110.4 321.73 111.4 327.38 116.65 328.32 118.27 320.1 132.62 324.52 129.57 341.07 127.93 349.91 106.04 336.75 108.38 332.81 86.07 330.16 89.68 315.01 Z"
          data-mrisynd="dma 771"
          data-state_name="Yuma-El Centro, AZ-CA"
          id="771"
        />
        <path
          className="white"
          d="M 212.31 249.09 216.12 220.55 239.85 223.64 240.41 225.52 233.15 228.46 224.6 232.21 224.2 235.3 237.19 236.94 236.35 243.99 227.02 242.24 232 250.72 230.29 253.23 212.31 249.09 Z"
          data-mrisynd="dma 773"
          data-state_name="Grand Junction-Montrose, CO"
          id="773"
        />
        <path
          className="white"
          d="M 197.78 353.59 194.85 374.46 161.99 369.57 127.93 349.91 129.57 341.07 175.53 348.86 197.78 353.59 Z"
          data-mrisynd="dma 789"
          data-state_name="Tucson (Sierra Vista), AZ"
          id="789"
        />
        <path
          className="white"
          d="M 195.5 263.98 209.92 266.01 211.23 256.71 213.53 254.14 235.06 256.76 233.57 269.06 268.84 273.01 286.27 274.57 284.92 290.43 294.68 292.93 293.43 306.19 281.44 310.17 280.48 320.52 283.3 320.77 282.51 330.83 284.15 330.99 285.43 339.35 295.89 341.82 294.24 361.21 287.95 363.5 283.57 361.13 282.77 371.18 277.87 370.77 239.77 367.04 242.57 346.96 233.23 351.22 226.65 350.43 224.41 369.5 209.65 367.67 208.54 376.27 194.85 374.46 197.78 353.59 204.26 306.83 198.3 310.32 191.83 309.53 194.37 289.95 191.7 289.55 195.5 263.98 Z"
          data-mrisynd="dma 790"
          data-state_name="Albuquerque-Santa Fe, NM"
          id="790"
        />
        <path
          className="white"
          d="M 292.32 88.58 282.76 88.48 281.04 83.27 274.91 82.09 275.55 76 278.15 77.97 284.48 76.9 285.89 68.39 286.19 65.39 287.86 65.54 296.81 71.39 298.7 80.9 292.32 88.58 Z"
          data-mrisynd="dma 798"
          data-state_name="Glendive, MT"
          id="798"
        />
        <path
          className="white"
          d="M 44.4 275.19 44.02 269.52 36.45 258.91 37.3 255.64 69.31 263.53 70.72 267.72 66.99 273.8 61.63 276.45 55.76 274.66 52.25 276.42 52.41 279.38 44.4 275.19 Z"
          data-mrisynd="dma 800"
          data-state_name="Bakersfield, CA"
          id="800"
        />
        <path
          className="white"
          d="M 26.73 82 31.25 83.22 34.43 81.16 35.95 75.82 41.9 77.6 42.51 79.19 39.55 80.2 38.85 87.17 57.26 91.26 57.23 92.7 51.21 102.44 48.75 103.64 49.75 109.12 47.4 112.35 36.12 114.93 26.64 113.76 22.93 110.61 17.44 111.65 17.77 106.35 14.41 104.89 17.8 98.35 20.9 98.67 21.2 96.54 18.49 97.97 26.73 82 Z"
          data-mrisynd="dma 801"
          data-state_name="Eugene, OR"
          id="801"
        />
        <path
          className="white"
          d="M 19.04 142.16 17.19 146.38 14.67 145.92 10.63 163.46 3.92 161.46 1 151.71 7.78 145.8 5.32 146.42 11.58 134.17 10.72 127.71 12.6 123.67 22.06 126.48 18.58 128.9 17.06 133.16 19.04 142.16 Z"
          data-mrisynd="dma 802"
          data-state_name="Eureka, CA"
          id="802"
        />
        <path
          className="white"
          d="M 28.68 226.36 27.97 229.65 22.31 229.47 15.9 219.77 12.9 222.53 13.28 209.01 15.04 209.05 15.68 215.29 19.83 217.52 15.46 206.75 18.37 204.98 15.39 203.05 13.24 208.37 8.91 201.56 7.03 202.95 8.77 198.49 10.41 201.99 2.02 182.77 5.38 168.31 3.92 161.46 10.63 163.46 19.07 166.43 18.62 178.29 23.09 195.61 22.69 200.74 20.65 200.41 19.72 202.97 24.69 207.47 28.42 206.94 27.95 209.93 25.91 223.25 28.68 226.36 Z"
          data-mrisynd="dma 807"
          data-state_name="San Francisco-Oakland-San Jose, CA"
          id="807"
        />
        <path
          className="white"
          d="M 95.33 42.57 93.96 53.84 116.16 57.23 113.79 65.4 116.67 67.8 115.38 74.34 111.77 81.18 103.55 81.7 104.33 88.8 87.5 84.64 88.73 81.52 85.92 79.02 88.69 68.72 90.51 68.72 91.51 64.92 90 64.53 70.04 59.15 71.79 52.79 73.47 53.21 75.63 47.4 74.27 43.84 78.53 39.54 77.5 34.91 81.5 32.09 95.33 42.57 Z"
          data-mrisynd="dma 810"
          data-state_name="Yakima-Pasco-Richland-Kennewick, WA"
          id="810"
        />
        <path
          className="white"
          d="M 44.1 164.08 47.82 150.26 66.35 155.18 70.28 140 79.1 142.24 95.19 146.12 111.55 149.85 107.31 168.73 113.38 170.08 105.52 204.82 81.76 202.59 92.38 224.91 87.97 244.39 80.23 232.79 66.33 229.51 60.36 222.52 62.08 220.01 57.23 212.55 57.27 208.28 52.04 206.25 52.88 195.03 56.06 194.88 59.26 182.59 57.11 182.32 58.06 175 52.9 169.21 48.44 170.33 47.85 165.06 44.1 164.08 Z"
          data-mrisynd="dma 811"
          data-state_name="Reno, NV"
          id="811"
        />
        <path
          className="white"
          d="M 14.41 104.89 17.77 106.35 17.44 111.65 22.93 110.61 26.64 113.76 36.12 114.93 47.4 112.35 49.75 109.12 48.75 103.64 51.21 102.44 79.48 110.12 74.67 126.12 82.58 128.07 79.1 142.24 70.28 140 56.76 136.46 50.37 134.63 46.22 149.84 31.63 145.77 31.59 142.02 25.21 143.94 24.5 147.55 19.04 142.16 17.06 133.16 18.58 128.9 22.06 126.48 12.6 123.67 11.29 118.14 13.6 111.26 12.55 106.71 14.41 104.89 Z"
          data-mrisynd="dma 813"
          data-state_name="Medford-Klamath Falls, OR"
          id="813"
        />
        <path
          className="white"
          d="M 93.36 6.97 94.44 12.69 92.23 14.48 95.39 23.99 98.34 28.76 110.77 28.16 112.47 31.18 108.57 32.78 102.41 40.01 98.04 38.99 95.33 42.57 81.5 32.09 77.5 34.91 78.53 39.54 74.27 43.84 75.63 47.4 73.47 53.21 71.79 52.79 43.54 44.72 42.85 46.93 39 45.5 40.56 38.82 39.72 43.87 41.27 42.57 42.19 44.61 41.94 39.2 43.89 38.28 40.79 36.85 41.17 33.59 42.22 35.32 45.75 33.67 42.15 31.17 40.77 33.04 42.24 17.26 40.4 12.13 42.08 4.36 50.16 11.19 61.19 14.07 59.96 14.46 62.83 18.44 65.33 16.08 65.78 21.3 62.51 24.35 62.24 21.56 56.02 29.07 60.43 28.8 56.72 28.56 66.96 21.15 66.77 24.35 64.5 23.73 64.11 27.16 63.08 25.95 65.23 28.59 63.31 32.66 61.48 32.1 63.01 29.97 59.93 33.94 60.49 29.36 58.04 32.63 56.03 31.99 57.98 32.75 55.6 34.19 58.09 33.28 56.51 35.35 59.42 33.58 59.91 35.86 63.54 31.99 65.65 33.7 66.77 26.07 72.21 20.58 70.3 15.79 68.93 16.5 69.82 19.12 68.3 17.16 68.65 14.97 71.04 14.47 67.81 9.88 70.45 11.47 70.04 8.76 71.81 8.93 68.86 1 93.36 6.97 Z M 68.6 21.62 65.55 14.55 67.81 11.69 69.26 14.13 66.02 14.62 67.31 19.2 69.47 19.47 68.6 21.62 Z M 63.46 9.29 62.93 5.89 64.64 8.33 63.46 9.29 Z M 65.33 29.03 66.12 31.33 63.99 31.81 65.33 29.03 Z M 66.04 8.05 66.06 10.8 64.64 9.52 66.04 8.05 Z"
          data-mrisynd="dma 819"
          data-state_name="Seattle-Tacoma, WA"
          fillRule="evenodd"
          id="819"
        />
        <path
          className="white"
          d="M 115.38 74.34 118.33 75.04 117.09 81.58 118.88 88.89 127.71 92.58 119.3 102.46 118.6 105.88 109.15 100.89 104.82 103.57 95.19 146.12 79.1 142.24 82.58 128.07 74.67 126.12 79.48 110.12 75.03 107.21 74.25 103.57 66.57 99.75 67.12 91.31 57.38 88.6 57.26 91.26 38.85 87.17 39.55 80.2 42.51 79.19 41.9 77.6 35.95 75.82 34.43 81.16 31.25 83.22 26.73 82 28.92 79.84 35.31 60.25 36.82 60.41 39 45.5 42.85 46.93 43.54 44.72 71.79 52.79 70.04 59.15 90 64.53 91.51 64.92 90.51 68.72 88.69 68.72 85.92 79.02 88.73 81.52 87.5 84.64 104.33 88.8 103.55 81.7 111.77 81.18 115.38 74.34 Z"
          data-mrisynd="dma 820"
          data-state_name="Portland, OR"
          id="820"
        />
        <path
          className="white"
          d="M 57.26 91.26 57.38 88.6 67.12 91.31 66.57 99.75 74.25 103.57 75.03 107.21 79.48 110.12 51.21 102.44 57.23 92.7 57.26 91.26 Z"
          data-mrisynd="dma 821"
          data-state_name="Bend, OR"
          id="821"
        />
        <path
          className="white"
          d="M 65.95 310.49 67.79 308.57 81.75 313.25 89.68 315.01 86.07 330.16 69.66 328.21 68.97 316.44 65.95 310.49 Z"
          data-mrisynd="dma 825"
          data-state_name="San Diego, CA"
          id="825"
        />
        <path
          className="white"
          d="M 12.9 222.53 15.9 219.77 22.31 229.47 27.97 229.65 34.73 240.96 31.94 247.24 37 255.54 20.05 250.91 14.43 239.09 14.75 233.64 17.68 232.48 18.29 227.61 12.9 222.53 Z"
          data-mrisynd="dma 828"
          data-state_name="Monterey-Salinas, CA"
          id="828"
        />
        <path
          className="white"
          d="M 118.34 289.81 87.97 244.39 92.38 224.91 81.76 202.59 105.52 204.82 115.56 206.99 126.85 218.91 140.75 221.66 134.6 253.57 131.72 268.91 129.46 271.83 126.55 268.9 120.62 268.79 119.84 279.84 118.34 289.81 Z"
          data-mrisynd="dma 839"
          data-state_name="Las Vegas, NV"
          id="839"
        />
        <path
          className="white"
          d="M 20.05 250.91 37 255.54 37.3 255.64 36.45 258.91 44.02 269.52 44.4 275.19 41.37 284.94 24.57 276.87 27.34 266.1 24.45 263.91 25.16 259.61 20.05 250.91 Z M 34.12 289.15 39.1 291.14 34.16 291.36 34.12 289.15 Z M 31.07 290 29.22 291.4 27.72 288.85 31.07 290 Z"
          data-mrisynd="dma 855"
          data-state_name="Santa Barbara-Santa Maria-San Luis O"
          fillRule="evenodd"
          id="855"
        />
        <path
          className="white"
          d="M 18.62 178.29 34 184.41 41.94 181.94 43.34 180.78 39.87 173.87 43.21 166.56 41.7 163.44 44.1 164.08 47.85 165.06 48.44 170.33 52.9 169.21 58.06 175 57.11 182.32 59.26 182.59 56.06 194.88 52.88 195.03 52.04 206.25 57.27 208.28 57.23 212.55 62.08 220.01 60.36 222.52 57.24 218.45 52.54 220.23 48.91 217.83 33.48 222.42 28.68 226.36 25.91 223.25 27.95 209.93 28.42 206.94 24.69 207.47 19.72 202.97 20.65 200.41 22.69 200.74 23.09 195.61 18.62 178.29 Z"
          data-mrisynd="dma 862"
          data-state_name="Sacramento-Stockton-Modesto, CA"
          id="862"
        />
        <path
          className="white"
          d="M 69.31 263.53 37.3 255.64 37 255.54 31.94 247.24 34.73 240.96 27.97 229.65 28.68 226.36 33.48 222.42 48.91 217.83 52.54 220.23 57.24 218.45 60.36 222.52 66.33 229.51 66.51 235.71 69.49 238.31 70.87 259.63 69.31 263.53 Z"
          data-mrisynd="dma 866"
          data-state_name="Fresno-Visalia, CA"
          id="866"
        />
        <path
          className="white"
          d="M 70.28 140 66.35 155.18 47.82 150.26 44.1 164.08 41.7 163.44 43.21 166.56 39.87 173.87 43.34 180.78 41.94 181.94 34 184.41 18.62 178.29 19.07 166.43 10.63 163.46 14.67 145.92 17.19 146.38 19.04 142.16 24.5 147.55 25.21 143.94 31.59 142.02 31.63 145.77 46.22 149.84 50.37 134.63 56.76 136.46 70.28 140 Z"
          data-mrisynd="dma 868"
          data-state_name="Chico-Redding, CA"
          id="868"
        />
        <path
          className="white"
          d="M 93.36 6.97 169.77 24.79 170.31 29.72 166.47 30.76 165.36 38.93 163.17 38.5 162.49 42.41 155.53 43.11 153.93 35.86 150.05 35.98 149.11 40.42 152.16 46.57 151.15 49.21 152.52 50.84 150.62 51.56 155.62 55.84 160.66 67.79 166.28 69.83 161.73 78.78 162.6 84.05 159.83 85.68 159.04 89.75 155.73 90.29 157.7 94.57 155.98 96.21 139.03 92.27 134.2 93.42 134.34 90.31 129.77 89.31 127.71 92.58 118.88 88.89 117.09 81.58 118.33 75.04 115.38 74.34 116.67 67.8 113.79 65.4 116.16 57.23 93.96 53.84 95.33 42.57 98.04 38.99 102.41 40.01 108.57 32.78 112.47 31.18 110.77 28.16 98.34 28.76 95.39 23.99 92.23 14.48 94.44 12.69 93.36 6.97 Z"
          data-mrisynd="dma 881"
          data-state_name="Spokane, WA"
          id="881"
        />
        <path
          className="white"
          d="M 41.37 284.94 44.4 275.19 52.41 279.38 52.25 276.42 55.76 274.66 61.63 276.45 66.99 273.8 70.72 267.72 69.31 263.53 70.87 259.63 69.49 238.31 66.51 235.71 66.33 229.51 80.23 232.79 87.97 244.39 118.34 289.81 120.1 300.88 123.34 305.37 116 310.13 112.53 319.57 96.05 316.32 89.68 315.01 81.75 313.25 67.79 308.57 65.95 310.49 59.49 301.74 54.85 300.84 54.38 294.98 45.4 291.4 41.37 284.94 Z M 49 315.79 48.54 313.36 51.68 318.37 49 315.79 Z M 52.43 306.09 54.56 309.37 50.64 305.05 52.43 306.09 Z"
          data-mrisynd="dma 803"
          data-state_name="Los Angeles, CA"
          fillRule="evenodd"
          id="803"
        />
      </g>
    </svg>
  );
};

export default Markets;
